/* eslint-disable react-hooks/rules-of-hooks */
import { React, useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import {
  Layout,
  Row,
  Col,
  Button,
  PageHeader,
  Checkbox,
  Form,
  Select,
  Input,
  Radio,
  Tooltip,
  Collapse,
  Skeleton,
  Card,
  Dropdown,
  message,
} from "antd";
import { MultiSelect } from "react-multi-select-component";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { PaperHeaderButtonStyle, PaperBlockList } from "../../pageStyled";
import paperCover from "../../../Assets/Images/paper-machine-cover.png";
import PaperMachine from "../../../Assets/Images/paper-machine.png";
import {
  PaperMachineRecordsData,
  PaperMachineScroll,
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
  AlertDiv,
} from "../../pageStyled";
import SimpleBar from "simplebar-react";
import { HaberForm } from "../../styledElements";
import "simplebar/dist/simplebar.min.css";
import { useNavigate } from "react-router-dom";
import {
  getMachineGradeSelect,
  getAllGrades,
  getGradeQualities,
  getGradeProductParameter,
} from "../../../Services/settingsServices";
import {
  getDeckleMachineOrders,
  getDeckleMachineOrdersForMultiStage,
  machineSelectedOrders,
  paperMachineListData,
  postPaperMachineList,
} from "../../../Services/machineServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import nextArrow from "../../../Assets/Icons/back-arrow.svg";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import { getCustomersForConfiguration } from "../../../Services/customerServices";
import styled from "styled-components";
import { getRewindersByMachineCode } from "../../../Services/machineServices";
import { getCuttersByMachineCode } from "../../../Services/machineServices";
import { getUnitData } from "../../../Services/measurementService";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  CoversionFactorUnitsToCM,
  CoversionFactorCMToUnits,
  conversionFactorTonneToUnits,
  conversionFactorUnitsToTonne,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import {
  cancelJobCard,
  getQualitySelectedOrders,
  getQualitySelectedOrdersForMultiStage,
} from "../../../Services/deckleMatchServices";
import PaperMachineCardShimmer from "../../../Components/CardShimmer/paperMachineCardShimmer.jsx";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext.jsx";

const PlanningStyle = styled.div`
  .ant-radio-group-solid label {
    width: 199px !important;
  }
`;

const ProcessTypeStyle = styled.div`
  .switchRadio .ant-radio-group-solid label:last-child {
    height: 50px;
  }
  .switchRadio
    .ant-radio-group-solid
    label.ant-radio-button-wrapper-checked
    span {
    height: 50px;
    font-size: 14px;
    line-height: 19px;
  }
  .switchRadio.twoSwitch .ant-radio-group-solid {
    height: 50px;
  }
  .switchRadio .ant-radio-group-solid label.ant-radio-button-wrapper-checked {
    height: 50px;
  }
  .switchRadio .ant-radio-group-solid label span:last-child {
    font-size: 14px;
    line-height: 19px;
  }
  .switchRadio .ant-radio-group-solid label:first-child {
    height: 50px;
  }
`;

const CollapseStyle = styled.div`
  .ant-collapse-borderless {
  }
  .ant-collapse-header {
    font-size: 20px;
    margin-left: 10px;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0px;
  }
`;

const CardShimmerStyle = styled.div`
  .ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding: 0px;
  }
  .ant-skeleton-content .ant-skeleton-paragraph {
    margin-top: 0px;
  }
  .ant-skeleton-content .ant-skeleton-paragraph > li {
    width: 100% !important;
  }
  .ant-select .ant-skeleton-element {
    width: 100%;
    min-width: 100%;
  }
  .ant-skeleton ant-skeleton-element ant-skeleton-active {
    width: 100%;
    min-width: 100%;
  }
  .ant-skeleton-element .ant-skeleton-button {
    min-width: 200px !important;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element .ant-skeleton-input {
    min-width: 0px;
    width: 100%;
    border-radius: 3px;
  }
  .ant-skeleton-element {
    width: 100% !important;
  }
  .ant-skeleton-element .ant-skeleton-image {
    min-width: 0px;
    width: 100%;
  }
`;

const LabelContainer = styled.div`
  display:flex;
  justify-content:flex-start;
  gap:20px;
  &>p{
    font-weight: bold;
    color: rgba(50, 49, 48, 1);
    margin-right: 10px;
  }
  &>span {
    color:rgba(59, 58, 57, 1);
    font-size: 12px;
    margin-top: 2px;
    &>span{
      color: rgba(234, 101, 91, 1);
    }
  }
`

const { Option } = Select;
const { Panel } = Collapse;

const deckleWidthData = ["mm", "cm"];

const orderTypeOptions = [
  { label: "Reel", value: "reel" },
  { label: "Sheet", value: "sheet" },
  { label: "Both", value: "both" },
];

const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const GSMWiseCards = ({form,field}) => {
    let units = form.getFieldValue("units") || (getFormObject()?.units?.gsm_wise_configs && Object.values(getFormObject()?.units?.gsm_wise_configs)[0]) || (getFormObject()?.machine_data[0]?.units?.gsm_wise_configs && Object.values(getFormObject()?.machine_data[0]?.units?.gsm_wise_configs)[0]) ;

  const calculateEffectiveDeckleLength = () => {
    const max_deckle_width = form.getFieldValue(['gsmWiseWidths',field.name,'max_deckle_width']);
    const left_edge_trim = form.getFieldValue(['gsmWiseWidths',field.name,'left_edge_trim']);
    const right_edge_trim = form.getFieldValue(['gsmWiseWidths',field.name,'right_edge_trim']);  
    
    let effective_deckle_length;
    if(max_deckle_width && left_edge_trim && right_edge_trim)
      effective_deckle_length = max_deckle_width - left_edge_trim - right_edge_trim;

    form.setFields([{
      name: ['gsmWiseWidths',field.name,'effective_deckle_length'],
      value: effective_deckle_length?.toFixed(3)
    }]);
  }

  const calculateMaxAllowedTrimLoss = () =>{
    const max_deckle_width = form.getFieldValue(['gsmWiseWidths',field.name,'max_deckle_width']);
    const min_deckle_width = form.getFieldValue(['gsmWiseWidths',field.name,'min_deckle_width']);

    let max_allowed_trim_loss;
    if(max_deckle_width && min_deckle_width)
      max_allowed_trim_loss = (max_deckle_width - min_deckle_width) * 100 / max_deckle_width;

    form.setFields([{
      name: ['gsmWiseWidths',field.name,'max_allowed_trim_loss_percentage'],
      value: max_allowed_trim_loss?.toFixed(3),
    }])

  }



  return (
    <div style={{backgroundColor:"rgba(250, 249, 248, 1)",margin:"0px 30px 10px"}}>
      <Row style={{marginBottom:"5px"}} gutter={3}>
        <Col span={4} style={{fontSize:"12px", color:"rgba(59, 58, 57, 1)",display:"flex",alignItems:"center"}}>
          <span >{`Deckle Width (${units?.effective_deckle_length})`}</span>
        </Col>
        <Col span={4}>
          <Form.Item
            {...field}
            name={[field.name,"min_deckle_width"]}
            normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            rules={[
              {
                required: true,
                message: "This field is required!"
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                message: "Only numeric characters are allowed upto 3 decimal points!",
              },     
              {
                validator: (_,value)=>{
                  const max_width = form.getFieldValue(["gsmWiseWidths",field.name,"max_deckle_width"]);
                  if(parseFloat(value)>parseFloat(max_width))
                    return Promise.reject("Min. width cannot be greater than Max. width!");
                  form.setFields([
                      {
                        name: ["gsmWiseWidths",field.name,"max_deckle_width"],
                        errors: [],
                      }
                    ])
                  return Promise.resolve();
                }
              }   
            ]}
          >
            <Input placeholder="Min." onChange={calculateMaxAllowedTrimLoss}/>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            {...field}
            name={[field.name,"max_deckle_width"]}
            normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            rules={[
              {
                required: true,
                message: "This field is required!"
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                message: "Only numeric characters are allowed upto 3 decimal points!",
              },     
              {
                validator: (_,value)=>{
                  const min_width = form.getFieldValue(["gsmWiseWidths",field.name,"min_deckle_width"]);
                  if(parseFloat(value)<parseFloat(min_width))
                    return Promise.reject("Max. width cannot be less than Min. width!");
                  form.setFields([
                      {
                        name: ["gsmWiseWidths",field.name,"min_deckle_width"],
                        errors: [],
                      }
                    ])
                  return Promise.resolve();
                }
              }   
            ]}
          >
            <Input onChange={()=>{calculateEffectiveDeckleLength();calculateMaxAllowedTrimLoss()}} placeholder="Max."/>
          </Form.Item>
        </Col>
        <Col span={4} style={{fontSize:"12px", color:"rgba(59, 58, 57, 1)",display:"flex",alignItems:"center",paddingInlineStart:"22px"}}>
          <span>{`Edge Trims (${units?.effective_deckle_length})`}</span>
        </Col>
        <Col span={4}>
          <Form.Item
            {...field}
            name={[field.name,"left_edge_trim"]}
            normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            rules={[
              {
                required: true,
                message: "This field is required!"
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                message: "Only numeric characters are allowed upto 3 decimal points!",
              },
              {
                validator : (_,value) => {
                  const min_width = form.getFieldValue(["gsmWiseWidths",field.name,"min_deckle_width"]);
                  const max_width = form.getFieldValue(["gsmWiseWidths",field.name,"max_deckle_width"]);
                  const right_trim = form.getFieldValue(["gsmWiseWidths",field.name,"right_edge_trim"]);

                  if(max_width - min_width <= value + right_trim)
                    return Promise.reject("Total edge trim must be less than difference of Deckle Width min and max");

                  return Promise.resolve();

                }
              }
            ]}
          >
            <Input onChange={calculateEffectiveDeckleLength} placeholder="Left"/>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            {...field}
            name={[field.name,"right_edge_trim"]}
            normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
            }}
            rules={[
              {
                required: true,
                message: "This field is required!"
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                message: "Only numeric characters are allowed upto 3 decimal points!",
              },
              {
                validator : (_,value) => {
                  const min_width = form.getFieldValue(["gsmWiseWidths",field.name,"min_deckle_width"]);
                  const max_width = form.getFieldValue(["gsmWiseWidths",field.name,"max_deckle_width"]);
                  const left_trim = form.getFieldValue(["gsmWiseWidths",field.name,"left_edge_trim"]);

                  if(max_width - min_width <= value + left_trim)
                    return Promise.reject("Total edge trim must be less than difference of Deckle Width min and max");

                  return Promise.resolve();

                }
              }
            ]}
          >
            <Input onChange={calculateEffectiveDeckleLength} placeholder="Right"/>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={3}>
        <Col span={4} style={{fontSize:"12px", color:"rgba(59, 58, 57, 1)",display:"flex",alignItems:"center"}}>
          <span>{`Effective Deckle Length (${units?.effective_deckle_length})`}</span>
        </Col>
        <Col span={4}></Col>
        <Col span={4}>
          <Form.Item
            {...field}
            name={[field.name,"effective_deckle_length"]}
            normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            rules={[
              {
                required: true,
                message: "This field is required!"
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                message: "Only numeric characters are allowed upto 3 decimal points!",
              }  
            ]}
          >
            <Input disabled style={{backgroundColor:"#EDEBE9"}}/>
          </Form.Item>
        </Col>
        <Col span={4} style={{fontSize:"12px", color:"rgba(59, 58, 57, 1)",display:"flex",alignItems:"center",paddingInlineStart:"22px"}}>
          <span>Max Allowed Trim Loss (%)</span>
        </Col>
        <Col span={4}></Col>
        <Col span={4}>
          <Form.Item
            {...field}
            name={[field.name,"max_allowed_trim_loss_percentage"]}
            normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            rules={[
              {
                required: true,
                message: "This field is required!"
              },
              {
                pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                message: "Only numeric characters are allowed upto 3 decimal points!",
              }  
            ]}
          >
            <Input disabled style={{backgroundColor:"#EDEBE9"}}/>
          </Form.Item>
        </Col>
      </Row>
    </div>
  )
}

const PaperMachineData = (props) => {
  const source = axios.CancelToken.source();
  const {
    paperMachineData,
    setPaperMacineData,
      setPaperMachineOrdersData
    } = useContext(JobCardDataContext);
  const [formValues, setFormValues] = useState(getFormObject());
  const routerLocation = useLocation();
  
    const location = paperMachineData  ? paperMachineData : routerLocation;

  const [paperMachineCheckedBoxId, setPaperMachineCheckedBoxId] = useState(
    formValues && formValues.machine_code ? formValues.machine_code : null
  );
  const [globalSettings, setGlobalSettings] = useState([]);
  const [orderWindowType, setOrderWindowType] = useState(null);
  const [isProductDropdownOpen, setProductDropdown] = useState(false);

  const [selected, setSelected] = useState([]);
  const [paperMachineList, setPaperMachineList] = useState();
  const [getPaperMachineList, setGetPaperMachineList] = useState();
  const [effectiveDeckle, setEffectiveDeckle] = useState(0);
  const history = useNavigate();
  const [form] = Form.useForm();
  const [grades, setGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState(
    formValues && formValues.grade ? formValues.grade : null
  );
  const [selectedGQ, setSelectedGQ] = useState(
    formValues && formValues?.grades_and_qualities
      ? formValues.grades_and_qualities
      : []
  );
  const [showError, setShowError] = useState({ error: false, message: "" });
  const [proceed, setProceed] = useState(false);
  const [isGradeDropdownOpen, setGradeDropdown] = useState(false);
  const [isCutterDropdownOpen, setCutterDropdown] = useState(false);
  const [isRewinderDropdownOpen, setRewinderDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [updatedOrderTypeOptions, setUpdatedOrderTypeOptions] = useState(
    formValues && formValues.order_types
      ? formValues.order_types
      : [
          { label: "Reel", value: "reel" },
          { label: "Sheet", value: "sheet" },
          { label: "Both", value: "both" },
        ]
  );
  const orderWindowTypeOptions = [
    { label: "Fixed Period", value: "fixed" },
    { label: "Flexible ", value: "flexible" },
  ];
  const [loadings, setLoadings] = useState(false);
  const [orderType, setOrderType] = useState(
    formValues && formValues.order_type ? formValues.order_type : ""
  );

  const [customersList, setCustomersList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [selectedCustomerList, setSelectedCustomerList] = useState([]);
  const [showBFRange, setShowBFRange] = useState(false);
  const [showMoisture, setShowMoisture] = useState(false);
  const [rewindingCuttingTabArray, setRewindingCuttingTabArray] = useState([
    { label: "Rewinding", value: "rewinding" },
    { label: "Cutting", value: "cutting" },
  ]);
  const [type, setType] = useState(
    location?.state?.selected_type
      ? location?.state?.selected_type
      : "rewinding"
  );
  const [allRewinders, setAllRewinders] = useState(
    location?.state?.rewinder_data ? location?.state?.rewinder_data : []
  );
  const [allCutters, setAllCutters] = useState(
    location?.state?.cutter_data ? location?.state?.cutter_data : []
  );
  const [selectedRewinder, setSelectedRewinder] = useState(
    location?.state?.selected_rewinder
      ? location?.state?.selected_rewinder
      : null
  );
  const [selectedCutter, setSelectedCutter] = useState(
    location.state && location?.state.selected_cutter
      ? location?.state.selected_cutter
      : null
  );
  const [rewinderMinWidth, setRewinderMinWidth] = useState(
    location?.state?.rewinder_minWidth
    ? location?.state?.rewinder_minWidth
    : null
  );
  const [rewinderMaxWidth, setRewinderMaxWidth] = useState(
    location?.state?.rewinder_maxWidth
    ? location?.state?.rewinder_maxWidth
    : null
  );
  const [cutterMinWidth, setCutterMinWidth] = useState(
    location?.state?.cutter_minWidth ? location.state.cutter_minWidth : null
  );
  const [cutterMaxWidth, setCutterMaxWidth] = useState(
    location?.state?.cutter_maxWidth ? location?.state?.cutter_maxWidth : null
  );
  const [cutterUnit, setCutterUnit] = useState(
    location.state ? location.state.selected_cutter_unit : ""
  );
  const [cutterUnits,setCutterUnits] = useState();
  const [rewinderUnit, setRewinderUnit] = useState(
    location.state ? location.state.selected_rewinder_unit : ""
  );
  const [maxNoOfCutters, setMaxNoOfCutters] = useState(
    location?.state?.max_NoOfCutters ? location?.state?.max_NoOfCutters : null
  );
  const [leftEdgeTrim, setLeftEdgeTrim] = useState(
    location?.state?.left_edge_trim ? location?.state?.left_edge_trim : null
  );
  const [rightEdgeTrim, setRightEdgeTrim] = useState(
    location?.state?.right_edge_trim ? location?.state?.right_edge_trim : null
  );
  const [inititalOrderType, setInitialOrderType] = useState(
    location?.state?.initital_OrderType
    ? location?.state?.initital_OrderType
    : ""
  );
  const [code, setCode] = useState(location?.state?.code);
  const [isEnabled, setEnabled] = useState(
    location?.state?.is_enabled ? location?.state?.is_enabled : false
  );
  const [selectedMachineCode, setSelectedMachineCode] = useState(
    location?.state?.machine_code
  );
  const [productParameters, setProductParameters] = useState(
    formValues && formValues.product_parameters
    ? formValues.product_parameters
    : []
  );
  const [maxNoOfCuttersForCutter, setMaxNoOfCuttersForCutter] = useState(
    location?.state?.max_NoOfCutters_cutter
      ? location?.state?.max_NoOfCutters_cutter
      : null
  );
  const [leftEdgeTrimForCutter, setLeftEdgeTrimForCutter] = useState(
    location?.state?.left_edge_trim_cutter
      ? location?.state?.left_edge_trim_cutter
      : null
  );
  const [rightEdgeTrimForCutter, setRightEdgeTrimForCutter] = useState(
    location?.state?.right_edge_trim_cutter
      ? location?.state?.right_edge_trim_cutter
      : null
  );

  const [isDummyJC, setIsDummyJC] = useState(location?.state?.isDummyJC ? location?.state?.isDummyJC : false);

  const [planningType, setPlanningType] = useState(
  isDummyJC ? 'purchaseOrder'  : formValues && formValues.planning_type
      ? formValues.planning_type
      : "quality"
  );

  const [rerender, setRerender] = useState(false);
  const scrollPositionsRef = useRef(null);
  const disabledNext = useRef(false);
  const [disableButton, setDisableButton] = useState(false);
  const convertingProcessTabArray = [
    { label: "Multi Stage Converting Process", value: "multiStage" },
    { label: "Single Stage Converting Process", value: "singleStage" },
  ];

  const [processType, setProcessType] = useState(
    isDummyJC ? 'singleStage' :
    location && location.state ? location.state.processType : "singleStage"
  );
  // const minWeight1 = 1;
  const minWeight1 =
    location && location.state && location.state.minWeight
      ? location.state.minWeight
      : 0.5;

  const planningCriteria = [
    { label: "Quality", value: "quality" },
    { label: "Purchase Order", value: "purchaseOrder" },
  ];
  const [unitData, setUnitData] = useState();
  const [trimValidaton, setTrimValidaton] = useState(false);
  const isScrollSetRef = useRef(true);
  const [isGSMError, setIsGSMError] = useState(false);
  const [isDiaError, setIsIDiaError] = useState(false);
  const [activeKey,setActiveKey] = useState([]);

  const Label = ({ind,isActive,form}) =>{
    const values = form.getFieldValue(["gsmWiseWidths",ind])
    let units = form.getFieldValue("units") || (getFormObject()?.units?.gsm_wise_configs && Object.values(getFormObject()?.units?.gsm_wise_configs)[0]) || (getFormObject()?.machine_data[0]?.units?.gsm_wise_configs && Object.values(getFormObject()?.machine_data[0]?.units?.gsm_wise_configs)[0]) ;
    return (
      <LabelContainer>
        <p>{`GSM Range ${ind+1}`}</p>
        <span>GSM: <span>{`${values?.min_gsm?values?.min_gsm:0} - ${values?.max_gsm?values?.max_gsm:0}`}</span></span>
        {isActive && <span>Deckle width: <span>{`${values?.min_deckle_width?values?.min_deckle_width:0} - ${values?.max_deckle_width?values?.max_deckle_width:0} ${units?.effective_deckle_length}`}</span></span>}
      </LabelContainer>
    )
  } 

  const scrollToElement = () => {
    if (
      paperMachineCheckedBoxId &&
      formValues &&
      formValues.machine_code &&
      isScrollSetRef.current
    ) {
      const currentRef = scrollPositionsRef.current;
      if (currentRef?.input) {
        currentRef.input.scrollIntoView();
        window.scrollTo({
          top: 0,
        });
        isScrollSetRef.current = false;
      }
    }
  };
  const OnProductToggleSelect = () => {
    setProductDropdown((prevState) => !prevState);
  };
  const handleOrderWindowTypeChange = (value) => {
    form.setFieldsValue({ order_window: 0 });

    setOrderWindowType(value);
  };
  // console.log(location.state)
  useEffect(() => {
    (async () => {
      if (
        formValues?.effective_deckle_length &&
        formValues?.processType == "singleStage"
      ) {
        form.setFieldsValue({
          effective_deckle_length: formValues.effective_deckle_length,
        });
      }
      if (
        formValues?.processType == "multiStage" &&
        formValues?.machine_data?.[0]?.effective_deckle_length &&
        formValues?.machine_data?.[1]?.effective_deckle_length
      ) {
        form.setFieldsValue({
          effective_deckle_length:
            formValues?.machine_data?.[0]?.effective_deckle_length,
          effective_deckle_length_cutter:
            formValues?.machine_data?.[1]?.effective_deckle_length,
        });
      }
      await getUnitData()
        .then((response) => {
          setUnitData(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
      })();
  }, []);

  useEffect(()=>{
    if(processType == "multiStage")
    {
      if(allRewinders.length==1)
        onRewinderChange(allRewinders[0]?.name);
      if(allCutters.filter(data=>data.type=="simplex").length==1)
        onCutterChange(allCutters.filter(data=>data.type=="simplex")[0]?.name);
    }
    else{
      if (type == "rewinding") {
        if (allRewinders.length == 1) 
          onRewinderChange(allRewinders[0]?.name);
      } else {
        if (allCutters.length == 1) 
          onCutterChange(allCutters[0]?.name);
      }
    }
    form.setFieldsValue({"order_type":(orderType=="sheet"?"sheet":"both")});

    if(processType == "multiStage" || type == "rewinding")
    {
      let rewinder = allRewinders?.filter(
        (rewinder) => rewinder?.name?.toLowerCase() === selectedRewinder?.toLowerCase()
      );

      const units = rewinder.length
          ? Object.keys(rewinder[0]?.gsm_wise_configs).length
            ? rewinder[0]?.units?.gsm_wise_configs[selectedMachineCode] 
            : rewinder[0]?.units
          :{};

      form.setFieldsValue({
        units: units,
      })
    }
  },[allRewinders,allCutters,type,processType,selectedRewinder])

  useEffect(() => {
    // if((getPaperMachineList && paperMachineCheckedBoxId) && (selectedCutter || selectedRewinder) && unitData)
    //form.setFieldsValue({'min_weight_per_partition' : (formValues?.partitionWeightUnit && location?.state?.minWeigh)  ? (location.state.minWeight * conversionFactorUnitsToTonne[formValues.partitionWeightUnit] * conversionFactorTonneToUnits[formValues.partitionWeightUnit]).toFixed(3) : (0.5 * conversionFactorTonneToUnits[unitData?.units_management.weight.default]).toFixed(3)});
  }, [
    unitData,
    getPaperMachineList,
    paperMachineCheckedBoxId,
    selectedCutter,
    selectedRewinder,
  ]);

  useEffect(() => {
    (async () => {
      await getAllPaperMachineList();
      await getGradeAndQuality();
      await getAllCustomers();
      await getAllGrades()
        .then((response) => {
          setGrades(response);
          // console.log("Grades", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
      return () => {
        if (!proceed) {
          setFormObject(null); //to clear paper machine form data
        }
      };
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (selectedGrade) {
        await getGradeQualities(encodeURIComponent(selectedGrade))
          .then((response) => {
            // console.log("res", response);
            if (response.length == 0) {
              let objArray = selectedGQ;
              let tempConcat = objArray.concat({
                grade: selectedGrade,
                quality: null,
              });
              tempConcat = Array.from(
                new Set(tempConcat.map(JSON.stringify))
              ).map(JSON.parse); //to remove duplicates
              setSelectedGQ(tempConcat);
            }
            let selectedQualities = [];
            const options = response.map((item) => {
              selectedGQ?.forEach((element) => {
                if (
                  element.grade == selectedGrade &&
                  element.quality == item.name
                ) {
                  selectedQualities.push({
                    value: item.name,
                    label: item.name,
                  });
                }
              });
              return { value: item.name, label: item.name };
            });
            setSelected(selectedQualities);
            setQualities(options);
            let tempShowBFRange = false;
            let tempShowMoisture = false;
            if (selectedGQ?.length) {
              selectedGQ?.forEach((gq) => {
                let filterGrade = productParameters.filter(
                  (param) => param[gq.grade]
                );
                if (filterGrade.length) {
                  if (filterGrade[0][gq.grade].showBF) {
                    tempShowBFRange = true;
                    setShowBFRange(true);
                  }
                  if (filterGrade[0][gq.grade].showMoisture) {
                    tempShowMoisture = true;
                    setShowMoisture(true);
                  }
                }
              });

              if (!tempShowBFRange) {
                form.setFieldsValue({ min_bf: "", max_bf: "" });
              }
              if (!tempShowMoisture) {
                form.setFieldsValue({ min_moisture: "", max_moisture: "" });
              }
            }
            if (formValues?.selectedCustomerList.length) {
              setSelectedCustomerList(formValues?.selectedCustomerList);
              setSelectedCustomer(formValues.selectedCustomerList);
            }
            // console.log("qualities", qualities);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    })();
  }, [selectedGrade]);

  useEffect(() => {
    form.resetFields();
  }, [paperMachineCheckedBoxId]);

  useEffect(() => {
    if (rerender) {
      setRerender(false);
    }
  }, [rerender]);

  useEffect(() => {
    if (getPaperMachineList && type && (selectedRewinder || selectedCutter)) {
      // const result =
      //   unit == "cm"
      //     ? getPaperMachineList.maximum_width -
      //       getPaperMachineList.left_edge_trim -
      //       getPaperMachineList.right_edge_trim
      //     : unit == "mm"
      //       ? getPaperMachineList.maximum_width -
      //       getPaperMachineList.left_edge_trim / 10 -
      //       getPaperMachineList.right_edge_trim / 10
      //       : "";
      // if (result < 0) {
      //   form.setFieldsValue({
      //     min_width: "",
      //     max_width: "",
      //     effective_deckle_length: "",
      //   });
      //   setShowError({
      //     error: true,
      //     message: `Total edge trim cannot be greater than deckle width`,
      //   });
      // } else {
      //   setShowError({
      //     error: false,
      //   });
      //   form.setFieldsValue({ effective_deckle_length: result.toFixed(2) });
      // }
      // if(type === "rewinding"){
      //   if(unit == "cm"){
      //     if((parseFloat(form.getFieldValue("min_width")) + parseFloat(form.getFieldValue("max_width"))) >=
      //     (rewinderMaxWidth - rewinderMinWidth)){
      //       form.setFieldsValue({
      //         min_width: "",
      //         max_width: "",
      //         effective_deckle_length: "",
      //       });
      //       setShowError({
      //         error: true,
      //         message: `Total edge trim should be less than difference of deckle range.`,
      //       });
      //     } else {
      //       let effeDeckleLen = rewinderMaxWidth - ((parseFloat(form.getFieldValue("min_width")) + parseFloat(form.getFieldValue("min_width"))));
      //         setShowError({
      //           error: false,
      //         });
      //         form.setFieldsValue({ effective_deckle_length: effeDeckleLen?.toFixed(2) });
      //       }
      //   } else{
      //     if(((getPaperMachineList?.left_edge_trim/10) + (getPaperMachineList?.right_edge_trim/10)) >= (rewinderMaxWidth - rewinderMinWidth)){

      //     }
      //   }
      // }
      edgeTrimValidation();
    } else {
      form.setFieldsValue({ effective_deckle_length: "" });
    }
  }, [getPaperMachineList, type, selectedRewinder, selectedCutter]);

  // useEffect(() => {
  //   let typeOptions = [];
  //   if(orderType === "both"){
  //     typeOptions = [];
  //     typeOptions.push(
  //       { label: "Reel", value: "reel" },
  //       {label: <Tooltip title={`Reel Type orders are allowed on this machine`}></Tooltip>, disabled: false});
  //     typeOptions.push(
  //       { label: "Sheet", value: "sheet" },
  //       {label: <Tooltip title={`Sheet Type orders are allowed on this machine`}></Tooltip>, disabled: false});
  //     typeOptions.push(
  //         { label: "Both", value: "both" },
  //         {label: <Tooltip title={`Both Type orders are allowed on this machine`}></Tooltip>, disabled: false});

  //     }
  //   setUpdatedOrderTypeOptions(typeOptions);

  // },[orderType]);

  useEffect(() => {
    setRerender(true);
  }, [isLoading]);
  const OnGradetoggleSelect = () => {
    setGradeDropdown((prevState) => !prevState);
  };

  useEffect(() => {
    setTimeout(() => {
      scrollToElement(); // Call scrollToElement when divRef is set
    }, 500);
  }, [scrollPositionsRef.current]);

  const OnRewindertoggleSelect = () => {
    setRewinderDropdown((prevState) => !prevState);
  };

  const OnCuttertoggleSelect = () => {
    setCutterDropdown((prevState) => !prevState);
  };

  const onTrimValidation = () => {
    if (
      form.getFieldValue("max_trim") *
        CoversionFactorUnitsToCM[form.getFieldValue("trim_unit")] >
      parseFloat(
        cutterMaxWidth * CoversionFactorUnitsToCM[cutterUnit.toLowerCase()]
      )
    ) {
      setTrimValidaton(true);
    } else {
      setTrimValidaton(false);
    }
  };

  const onGSMValidation = () => {
    if (
      parseFloat(form.getFieldValue("min_gsm")) >
      parseFloat(form.getFieldValue("max_gsm"))
    ) {
      setIsGSMError(true);
    } else {
      setIsGSMError(false);
    }
  };

  const onDiaValidation = () => {
    if (
      parseFloat(form.getFieldValue("min_dia")) >
      parseFloat(form.getFieldValue("max_dia"))
    ) {
      setIsIDiaError(true);
    } else {
      setIsIDiaError(false);
    }
  };

  const removeGQ = (index) => {
    let array = selectedGQ;
    let newArray = array.filter((item) => {
      return !(item.grade === index.grade && item.quality === index.quality);
    });
    setSelectedGQ(newArray);
    if (!newArray.length) {
      form.setFieldsValue({ grade: "" });
      setSelectedGrade("");
    }

    if (index.grade == selectedGrade) {
      let selectedQualities = selected.filter((item) => {
        return item.value !== index.quality;
      });
      setSelected(selectedQualities);
    }
    setShowBFRange(false);
    setShowMoisture(false);
    let tempShowBFRange = false;
    let tempShowMoisture = false;
    newArray.forEach((gq) => {
      let filterGrade = productParameters.filter((param) => param[gq.grade]);
      if (filterGrade.length) {
        if (filterGrade[0][gq.grade].showBF) {
          tempShowBFRange = true;
          setShowBFRange(true);
        }
        if (filterGrade[0][gq.grade].showMoisture) {
          tempShowMoisture = true;
          setShowMoisture(true);
        }
      }
    });

    let tempArray = newArray.filter((item) => item.grade === selectedGrade);
    if (tempArray.length == 0) {
      let filterGrade = productParameters.filter(
        (param) => param[selectedGrade]
      );
      if (filterGrade.length) {
        if (filterGrade[0][selectedGrade].showBF) {
          tempShowBFRange = true;
          setShowBFRange(true);
        }
        if (filterGrade[0][selectedGrade].showMoisture) {
          tempShowMoisture = true;
          setShowMoisture(true);
        }
      }
    }

    if (!tempShowBFRange) {
      form.setFieldsValue({ min_bf: "", max_bf: "" });
    }
    if (!tempShowMoisture) {
      form.setFieldsValue({ min_moisture: "", max_moisture: "" });
    }
  };

  const removeCustomer = (index) => {
    let array = selectedCustomerList;
    let newArray = array.filter((item) => {
      return !(item.value === index);
    });
    setSelectedCustomerList(newArray);
    let selectedCustomers = selectedCustomer.filter((item) => {
      return item.value !== index;
    });
    setSelectedCustomer(selectedCustomers);
  };

  const routeChange = () => {
    setProceed(true);
    form.submit();
  };

  const getProductParameters = async (grade) => {
    setShowBFRange(false);
    setShowMoisture(false);
    let tempShowBFRange = false;
    let tempShowMoisture = false;
    if (selectedGQ?.length) {
      selectedGQ?.forEach((gq) => {
        let filterGrade = productParameters.filter((param) => param[gq.grade]);
        if (filterGrade.length) {
          if (filterGrade[0][gq.grade].showBF) {
            tempShowBFRange = true;
            setShowBFRange(true);
          }
          if (filterGrade[0][gq.grade].showMoisture) {
            tempShowMoisture = true;
            setShowMoisture(true);
          }
        }
      });
      if (!tempShowBFRange) {
        form.setFieldsValue({ min_bf: "", max_bf: "" });
      }
      if (!tempShowMoisture) {
        form.setFieldsValue({ min_moisture: "", max_moisture: "" });
      }
    }
    await getGradeProductParameter(encodeURIComponent(grade))
      .then((response) => {
        //setQualities(response.map((quality) => quality.name));
        let tempShowBFRange = false;
        let tempShowMoisture = false;
        if (response.product) {
          let productParams = [...productParameters];
          let jsonObject = {
            [grade]: {
              showBF: response.product.burst_factor,
              showMoisture: response.product.moisture,
            },
          };
          productParams.push(jsonObject);
          setProductParameters(productParams);
          if (response.product.burst_factor) {
            tempShowBFRange = true;
            setShowBFRange(true);
          }
          if (response.product.moisture) {
            tempShowMoisture = true;
            setShowMoisture(true);
          }
        } else {
          let productParams = [...productParameters];
          let jsonObject = {
            [grade]: {
              showBF: true,
              showMoisture: false,
            },
          };
          productParams.push(jsonObject);
          setProductParameters(productParams);
          tempShowBFRange = true;
          setShowBFRange(true);
        }

        if (!tempShowBFRange) {
          form.setFieldsValue({ min_bf: "", max_bf: "" });
        }
        if (!tempShowMoisture) {
          form.setFieldsValue({ min_moisture: "", max_moisture: "" });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onChangeMachineQualitySelect = (value) => {
    setShowError({
      error: false,
      message: "",
    });
    setSelected(value);
    let objArray = [...selectedGQ];
    let tempObjArray = [];
    if (value.length > 0) {
      tempObjArray = value.map((quality) => {
        objArray = objArray.filter(
          (elem) => elem.grade !== selectedGrade && elem.value !== quality.value
        );
        return { grade: selectedGrade, quality: quality.value };
      });
    } else {
      objArray = objArray.filter((elem) => elem.grade !== selectedGrade);
    }
    let tempConcat = objArray.concat(tempObjArray);
    tempConcat = Array.from(new Set(tempConcat.map(JSON.stringify))).map(
      JSON.parse
    ); //to remove duplicates
    setSelectedGQ(tempConcat);
    // setShowBFRange(false);
    // setShowMoisture(false);
    // tempConcat.forEach(gq => {
    //   let filterGrade = productParameters[gp];
    //   if (filterGrade.showBF) {
    //     setShowBFRange(true);
    //   }
    //   if (filterGrade.showMoisture) {
    //     setShowMoisture(true);
    //   }
    // })
  };

  const onChangeCustomer = (value) => {
    setSelectedCustomer(value);
    let objArray = [...selectedCustomerList];
    let tempObjArray = [];
    if (value.length > 0) {
      tempObjArray = value.map((customer) => {
        objArray = objArray.filter((elem) => elem.value === customer.value);
        return customer;
      });
    } else {
      objArray = [];
    }
    let tempConcat = objArray.concat(tempObjArray);
    tempConcat = Array.from(new Set(tempConcat.map(JSON.stringify))).map(
      JSON.parse
    ); //to remove duplicates
    setSelectedCustomerList(tempConcat);
  };

  const handleOrderTypeChange = (e) => {
    setOrderType(e.target.value);
  };

  const handlePlanningTypeChange = (e) => {
    setFormValues();
    setShowError({
      error: false,
      message: "",
    });
    setSelected([]);
    setSelectedGQ([]);
    setSelectedGrade();
    setSelectedCustomer([]);
    setSelectedCustomerList([]);
    setProductParameters([]);
    setShowBFRange(false);
    setShowMoisture(false);
    form.setFieldsValue({ min_bf: "", max_bf: "", grade: [] });
    form.setFieldsValue({ min_moisture: "", max_moisture: "" });
    setPlanningType(e.target.value);
    // if (e.target.value === "purchaseOrder") {
    //   disabledNext.current = false;
    //   setDisableButton(false);
    // }
    // else {
    //   disabledNext.current = true;
    // }
    setRerender(true);
  };

  const handleProcessTypeChange = (e) => {
    setProcessType(e.target.value);
    setIsGSMError(false);
    setIsIDiaError(false);
    setSelectedGrade();
    setSelectedGQ([]);
    setSelected([]);
    setMaxNoOfCutters();
    setLeftEdgeTrim();
    setRightEdgeTrim();
    setMaxNoOfCuttersForCutter();
    setLeftEdgeTrimForCutter();
    setRightEdgeTrimForCutter();
    setCode();
    setSelectedCutter();
    setCutterMinWidth();
    setCutterMaxWidth();
    setCutterUnit();
    setCutterUnits();
    setSelectedRewinder();
    setRewinderMinWidth();
    setRewinderMaxWidth();
    setRewinderUnit();
    setEnabled(false);
    form.setFieldsValue({
      min_width: "",
      max_width: "",
      cutters: "",
      grade: null,
      quality: "",
    });
    if (processType == "multiStage") {
      form.setFieldsValue({
        min_width_cutter: "",
        max_width_cutter: "",
        cutters_cutter: "",
        grade: null,
        quality: "",
      });
    }
    if (e.target.value === "cutting" && processType == "multiStage") {
      setOrderType("sheet");
      form.setFieldsValue({ order_type: "sheet" });
      setEnabled(true);
    } else {
      setOrderType("reel");
      form.setFieldsValue({ order_type: "both" });
      setEnabled(false);
    }
  };
  //Fetch the details of select paper machine
  const getAllPaperMachineList = async () => {
    try {
      const response = await paperMachineListData({ status: "active" });
      setPaperMachineList(response);
      paperMachineCheckedBoxId &&
        setGetPaperMachineList(
          response.filter((item) => item.code === paperMachineCheckedBoxId)[0]
        );
    } catch (error) {
      console.log(error);
    }
  };

  const setMachineOrderType = async (selectedMachine) => {
    let orderTypesOptionsTemp = [];
    setSelectedCutter();
    setSelectedRewinder();
    setRewinderMinWidth();
    setRewinderMaxWidth();
    setCutterMinWidth();
    setCutterMaxWidth();
    setRewinderUnit();
    setCutterUnit();
    setCode();
    setOrderType();
    setMaxNoOfCutters();
    setLeftEdgeTrim();
    setRightEdgeTrim();
    setInitialOrderType();
    setEnabled(false);
    form.resetFields();
    setSelectedMachineCode(selectedMachine.code);
    if (
      selectedMachine.order_type === "both" ||
      selectedMachine.order_type === "reel"
    ) {
      if (selectedMachine.order_type === "both") {
        setOrderType("both");
        await getAllRewindersByMachineCode(selectedMachine?.code);
        await getAllCuttersByMachineCode(selectedMachine?.code);
        setEnabled(false);
      } else {
        setOrderType("reel");
        setEnabled(true);
        await getAllRewindersByMachineCode(selectedMachine?.code);
      }
      setType("rewinding");
    } else {
      getAllCuttersByMachineCode(selectedMachine?.code);
      form.setFieldsValue({ order_type: "sheet" });
      setOrderType("sheet");
      setType("cutting");
      setEnabled(true);
    }

    setOrderType(selectedMachine.order_type);
    setInitialOrderType(selectedMachine.order_type);

    if (selectedMachine?.order_type === "both") {
      orderTypeOptions.forEach((orderType) => {
        orderTypesOptionsTemp.push(orderType);
      });
    } else {
      orderTypeOptions.forEach((orderType) => {
        if (selectedMachine.order_type === orderType.value) {
          orderTypesOptionsTemp.push(orderType);
          form.setFieldsValue({ order_type: orderType.value });
        } else {
          orderTypesOptionsTemp.push({
            ...orderType,
            label: (
              <Tooltip
                title={`${orderType.label} Type orders are not allowed on this machine`}
              >
                <div className="switchRadio">{orderType.label}</div>
              </Tooltip>
            ),
            disabled: false,
          });
        }
      });
    }

    setUpdatedOrderTypeOptions(orderTypesOptionsTemp);
  };

  const getAllRewindersByMachineCode = async (machineCode) => {
    await getRewindersByMachineCode(machineCode).then((response) => {
      if (response) {
        setAllRewinders(response);
      }
    });
  };

  const getAllCuttersByMachineCode = async (machineCode) => {
    await getCuttersByMachineCode(machineCode).then((response) => {
      if (response) {
        setAllCutters(response);
      }
    });
  };

  const getGradeAndQuality = async () => {
    try {
      const response = await getMachineGradeSelect();
      setGlobalSettings(response.data.data.settings);

      setOrderWindowType(
        formValues
          ? formValues?.order_window_type === null|| formValues?.order_window_type === undefined
            ? response.data.data.settings.order_window_type
            : formValues?.order_window_type
          : response.data.data.settings.order_window_type
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getAllCustomers = async () => {
    getCustomersForConfiguration("", source)
      .then((response) => {
        if (response) {
          setCustomersList(
            response.map((customer) => {
              return { value: customer.code, label: customer.name };
            })
          );
        }
      })
      .catch((error) => {});
  };

  //nextbutton
  const onValuesChange = (values, allvalues) => {
    setFormValues();
    //setIsGSMError(false);
    //setIsIDiaError(false);
    if (allvalues.planning_type === "quality")
      if (
        processType == "multiStage" &&
        !allvalues.min_gsm &&
        !allvalues.max_gsm
      ) {
        disabledNext.current = true;
        setDisableButton(true);
      } else if (
        allvalues.grade &&
        allvalues.min_gsm &&
        allvalues.max_gsm &&
        (allvalues.cutters || form.getFieldValue("cutters")) &&
        (allvalues.order_window_type === "flexible" ||
          allvalues.order_window_type === "Flexible" ||
          allvalues.order_window) &&
          allvalues.order_type
        ) {
          disabledNext.current = false;
          setDisableButton(false);
        } else {
          disabledNext.current = true;
          setDisableButton(true);
        }
        else {
          if (
            processType == "multiStage" &&
            !allvalues.min_gsm &&
            !allvalues.max_gsm
          ) {
            disabledNext.current = true;
            setDisableButton(true);
          }
          if (
            (allvalues.effective_deckle_length_cutter ||
              form.getFieldValue("effective_deckle_length_cutter")) &&
              (allvalues.cutters_cutter || form.getFieldValue("cutters_cutter"))
            ) {
              disabledNext.current = false;
              setDisableButton(false);
            }
            if (
              (planningType != "singleStage" || allvalues.effective_deckle_length ||
                form.getFieldValue("effective_deckle_length")) &&
        (allvalues.cutters || form.getFieldValue("cutters"))
      ) {
        disabledNext.current = false;
        setDisableButton(false);
      } else {
        disabledNext.current = true;
        setDisableButton(true);
      }
    }
    setRerender(true);
  };

  //form function
  const onFinishPaperMachine = async (values) => {
    let rewinder = allRewinders?.filter(
      (rewinder) => rewinder?.name?.toLowerCase() === selectedRewinder?.toLowerCase()
    );

    if(rewinder.length && Object.keys(rewinder[0]?.gsm_wise_configs).length == 0)
    {
      rewinder[0].units={
        ...rewinder[0].units,
        gsm_wise_configs : {
          [selectedMachineCode] : {
            left_edge_trim: rewinder[0]?.units?.minimum_width,
            right_edge_trim: rewinder[0]?.units?.minimum_width,
            effective_deckle_length: rewinder[0]?.units?.minimum_width,
            max_deckle_width: rewinder[0]?.units?.minimum_width,
            min_deckle_width: rewinder[0]?.units?.minimum_width,
          }
        }
      }
    }

    let machineData = paperMachineList.filter((machine)=>machine.code == selectedMachineCode);
    if (isDummyJC) {
      if (processType == "singleStage" && selectedRewinder) {
        let req = {
          so_number: location.state.order,
          dummy:isDummyJC,
          data: [],
          rewinder_code: allRewinders?.find(
            (cutter) => cutter?.name === selectedRewinder
          )?.code,
          machine_type: "rewinder",
          maximum_cutters: parseFloat(form.getFieldValue(["cutters"]), 10),
          gsm_wise_configs: {
            [selectedMachineCode]: values.gsmWiseWidths,
          },
          effective_deckle_length: rewinder[0]?.effective_deckle_length,
          left_edge_trim: rewinder[0]?.left_edge_trim,
          right_edge_trim: rewinder[0]?.right_edge_trim,
          minimum_gsm: machineData[0]?.minimum_gsm,
          maximum_gsm: machineData[0]?.maximum_gsm,
          units: rewinder[0]?.units,
          move_to_selected_orders: [],
          processType: "singleStage",
          planningType: "purchaseOrder",
          machine_code: selectedMachineCode,
        };

        try {
          let response;
          response = await machineSelectedOrders(req);
          disabledNext.current = true;

          history("../order-summary", {
            state: {
              type: "selectOrders",
              body: req,
              data: response.data,
              orderResponse: null,
              processType: processType,
              isDummyJC: isDummyJC,
              so: location.state.order,
            },
          });
        } catch (error) {
          setLoadings(false);
                setShowError({
                  error: true,
                  message: error.response?.data?.msg,
                });
        }
      }
    } else {
      if (processType == "multiStage" && isDiaError) {
        return false;
      } else {
        if (planningType === "quality") {
          if (!isGSMError) {
            if (selectedGQ.length == 0) {
              setShowError({
                error: true,
                message:
                  "Please select at least 1 quality for the selected grade",
              });
            } else {
              setLoadings(true);

              let body = {};
              if (processType == "singleStage") {
                body = {
                  machine_code: selectedMachineCode,
                  machine_type: type === "rewinding" ? "rewinder" : "cutter",
                  ...(type === "rewinding" && {
                    rewinder_code: location?.state?.selected_type === type ? code : code,
                    effective_deckle_length: rewinder[0]?.effective_deckle_length,
                    left_edge_trim: rewinder[0]?.left_edge_trim,
                    right_edge_trim: rewinder[0]?.right_edge_trim,
                    gsm_wise_configs: {
                      [selectedMachineCode]: values?.gsmWiseWidths,
                    },
                  }),
                  ...(type === "cutting" && {
                    cutter_code:
                      location?.state?.selected_type === type ? code : code,
                      effective_deckle_length: form.getFieldValue([
                        "effective_deckle_length",
                      ])
                        ? parseFloat(
                            form.getFieldValue(["effective_deckle_length"])
                          )
                        : location.state?.body.effective_deckle_length
                        ? parseFloat(location.state?.body.effective_deckle_length)
                        : null,
                      left_edge_trim: parseFloat(
                        form.getFieldValue(["min_width"]),
                        10
                      ),
                      right_edge_trim: parseFloat(
                        form.getFieldValue(["max_width"]),
                        10
                      ),
                  }),
                  grades_and_qualities: selectedGQ,
                  minimum_gsm: parseFloat(values.min_gsm, 10),
                  maximum_gsm: parseFloat(values.max_gsm, 10),
                  
                  maximum_cutters: parseFloat(
                    form.getFieldValue(["cutters"]),
                    10
                  ),
                  order_window:
                    orderWindowType === "fixed"
                      ? parseFloat(values.order_window, 10)
                      : 0,
                  order_window_type: orderWindowType,
                  order_type: values.order_type,
                  ...(type === "cutting" && {
                    min_weight_per_partition: form.getFieldValue([
                      "min_weight_per_partition",
                    ])
                      ? form.getFieldValue(["min_weight_per_partition"])
                      : 0,
                  }),
                  units: {
                    ...(type === "cutting" && {
                    left_edge_trim: form.getFieldValue(["Unit"])
                      ? form.getFieldValue(["Unit"])
                      : formValues
                      ? formValues.Unit
                      : unitData?.units_management?.length.default,
                    right_edge_trim: form.getFieldValue(["Unit"])
                      ? form.getFieldValue(["Unit"])
                      : formValues
                      ? formValues.Unit
                      : unitData?.units_management?.length.default,
                    effective_deckle_length: form.getFieldValue(["Unit"])
                      ? form.getFieldValue(["Unit"])
                      : formValues
                      ? formValues.Unit
                      : unitData?.units_management?.length.default,
                    
                      min_weight_per_partition: form.getFieldValue([
                        "partitionWeightUnit",
                      ])
                        ? form.getFieldValue(["partitionWeightUnit"])
                        : formValues
                        ? formValues.partitionWeightUnit
                        : unitData?.units_management?.weight?.default,
                    }),
                    ...(type == "rewinding"  && {
                      ...rewinder[0]?.units
                    })
                  },
                  // burst_factor_range: {
                  //   minimum: showBFRange ? values.min_bf ? parseFloat(values.min_bf, 10) : "" : "",
                  //   maximum: showBFRange ? values.max_bf ? parseFloat(values.max_bf, 10) : "" : "",
                  // },
                  // moisture_range: {
                  //   minimum: showMoisture ? values.min_moisture ? parseFloat(values.min_moisture, 10) : "" : "",
                  //   maximum: showMoisture ? values.max_moisture ? parseFloat(values.max_moisture, 10) : "" : "",
                  // },
                  move_to_selected_orders: [],
                };
              } else {
                body = {
                  machine_code: selectedMachineCode,
                  grades_and_qualities: selectedGQ,
                  minimum_gsm: parseFloat(values.min_gsm, 10),
                  maximum_gsm: parseFloat(values.max_gsm, 10),
                  order_window:
                    orderWindowType === "fixed"
                      ? parseFloat(values.order_window, 10)
                      : 0,
                  order_window_type: orderWindowType,

                  order_type: values.order_type,

                  machine_data: [
                    {
                      rewinder_code: allRewinders?.find(
                        (cutter) => cutter?.name === selectedRewinder
                      )?.code,
                      machine_type: "rewinder",
                      gsm_wise_configs: {
                        [selectedMachineCode]: values.gsmWiseWidths,
                      },
                      maximum_cutters: parseFloat(
                        form.getFieldValue(["cutters"]),
                        10
                      ),
                      units: rewinder[0]?.units,
                    },
                    {
                      cutter_code: allCutters?.find(
                        (cutter) => cutter?.name === selectedCutter
                      )?.code,
                      machine_type: "cutter",
                      effective_deckle_length: form.getFieldValue([
                        "effective_deckle_length_cutter",
                      ])
                        ? parseFloat(
                            form.getFieldValue([
                              "effective_deckle_length_cutter",
                            ])
                          )
                        : location.state?.body.machine_data[1]
                            ?.effective_deckle_length
                        ? parseFloat(
                            location.state?.body.machine_data[1]
                              ?.effective_deckle_length
                          )
                        : null,
                      left_edge_trim: parseFloat(
                        form.getFieldValue(["min_width_cutter"]),
                        10
                      ),
                      right_edge_trim: parseFloat(
                        form.getFieldValue(["max_width_cutter"]),
                        10
                      ),
                      maximum_cutters: parseFloat(
                        form.getFieldValue(["cutters_cutter"]),
                        10
                      ),
                      minimum_chop_size: parseFloat(
                        form.getFieldValue(["min_chop"]),
                        10
                      ),
                      maximum_chop_size: parseFloat(
                        form.getFieldValue(["max_chop"]),
                        10
                      ),
                      minimum_reel_dia: parseFloat(
                        form.getFieldValue(["min_dia"]),
                        10
                      ),
                      maximum_reel_dia: parseFloat(
                        form.getFieldValue(["max_dia"]),
                        10
                      ),
                      allowed_trim: parseFloat(
                        form.getFieldValue(["max_trim"]),
                        10
                      ),
                      //min_weight_per_partition : form.getFieldValue(['min_weight_per_partition']) ? form.getFieldValue(['min_weight_per_partition']) : formValues ? formValues.partitionWeightUnit : unitData?.units_management?.weight?.default,
                      units: {
                        left_edge_trim: form.getFieldValue(["unit_cutter"])
                          ? form.getFieldValue(["unit_cutter"])
                          : formValues
                          ? formValues.unit_cutter
                          : unitData?.units_management?.length.default,
                        right_edge_trim: form.getFieldValue(["unit_cutter"])
                          ? form.getFieldValue(["unit_cutter"])
                          : formValues
                          ? formValues.unit_cutter
                          : unitData?.units_management?.length.default,
                        effective_deckle_length: form.getFieldValue([
                          "unit_cutter",
                        ])
                          ? form.getFieldValue(["unit_cutter"])
                          : formValues
                          ? formValues.unit_cutter
                          : unitData?.units_management?.length.default,
                        //min_weight_per_partition : form.getFieldValue(['partitionWeightUnit']) ? form.getFieldValue(['partitionWeightUnit']) : formValues ? formValues.partitionWeightUnit : unitData?.units_management?.weight?.default,
                        allowed_trim: form.getFieldValue(["trim_unit"]),
                        minimum_chop_size: form.getFieldValue(["chop_unit"]),
                        maximum_chop_size: form.getFieldValue(["chop_unit"]),
                        minimum_reel_dia: form.getFieldValue(["dia_unit"]),
                        maximum_reel_dia: form.getFieldValue(["dia_unit"]),
                      },
                    },
                  ],
                };
              }

              if (selectedCustomerList.length) {
                body["customers"] = selectedCustomerList.map((customer) => {
                  return customer.value;
                });
              }

              if (showBFRange && values.min_bf !== "" && values.max_bf !== "") {
                body["burst_factor_range"] = {
                  minimum: parseFloat(values.min_bf, 10),
                  maximum: parseFloat(values.max_bf, 10),
                };
              }
              if (
                showMoisture &&
                values.min_moisture !== "" &&
                values.max_moisture !== ""
              ) {
                body["moisture_range"] = {
                  minimum: parseFloat(values.min_moisture, 10),
                  maximum: parseFloat(values.max_moisture, 10),
                };
              }
              const formData = {
                ...body,
                grade: selectedGrade,
                // effective_deckle_length: form.getFieldValue([
                //   "effective_deckle_length",
                // ])
                //   ? parseFloat(form.getFieldValue(["effective_deckle_length"]))
                //   : location.state?.body.effective_deckle_length
                //   ? parseFloat(location.state?.body.effective_deckle_length)
                //   : null,
                // min_deckle_length: getPaperMachineList.minimum_width,
                // max_deckle_length: getPaperMachineList.maximum_width,
                selectedCustomerList: selectedCustomerList,
                product_parameters: productParameters,
                order_types: updatedOrderTypeOptions,
                planning_type: planningType,
                Unit: form.getFieldValue(["Unit"])
                  ? form.getFieldValue(["Unit"])
                  : formValues
                  ? formValues.Unit
                  : unitData?.units_management?.length.default,
                partitionWeightUnit: form.getFieldValue(["partitionWeightUnit"])
                  ? form.getFieldValue(["partitionWeightUnit"])
                  : formValues
                  ? formValues.partitionWeightUnit
                  : unitData?.units_management?.weight?.default,
                unit_cutter: form.getFieldValue(["unit_cutter"])
                  ? form.getFieldValue(["unit_cutter"])
                  : formValues
                  ? formValues.unit_cutter
                  : unitData?.units_management?.length.default,
                processType: processType,
                order_type: inititalOrderType,
              };

              try {
                let response;
                if (processType == "singleStage") {
                  response = await getQualitySelectedOrders(
                    body,
                    {
                      page: 1,
                      size: 10,
                      sort_by: "po__date",
                      sort_type: "ascending",
                    },
                    "selected_orders"
                  );
                }
                if (processType == "multiStage") {
                  response = await getQualitySelectedOrdersForMultiStage(
                    body,
                    {
                      page: 1,
                      size: 10,
                      sort_by: "po__date",
                      sort_type: "ascending",
                    },
                    "selected_orders"
                  );
                }
                // setShowError({
                //   error: false,
                // });
                // console.log("number of groups", response.data.data.groups.length);
                setFormObject(formData);
                setPaperMachineCheckedBoxId(null);
                setPaperMachineOrdersData({
                  selected_rewinder: selectedRewinder,
                  selected_cutter: selectedCutter,
                  selected_rewinder_unit: rewinderUnit,
                  selected_cutter_unit: cutterUnit,
                  rewinder_data: allRewinders,
                  cutter_data: allCutters,
                  selected_type: type,
                  rewinder_minWidth: rewinderMinWidth,
                  rewinder_maxWidth: rewinderMaxWidth,
                  cutter_minWidth: cutterMinWidth,
                  cutter_maxWidth: cutterMaxWidth,
                  max_NoOfCutters: maxNoOfCutters,
                  ...((type === "cutting" || processType == "multiStage") && {
                    minWeight: body.min_weight_per_partition,
                  }),
                  rewinder_gsm_wise_configs: values?.gsmWiseWidths,
                  left_edge_trim: leftEdgeTrim,
                  right_edge_trim: rightEdgeTrim,
                  orderResponse: response,
                  maximum_burst_factor: values.max_bf
                    ? parseFloat(values.max_bf, 10)
                    : 0,
                  minimum_burst_factor: values.min_bf
                    ? parseFloat(values.min_bf, 10)
                    : 0,
                  maximum_gsm: values.max_gsm
                    ? parseFloat(values.max_gsm, 10)
                    : 0,
                  minimum_gsm: values.min_gsm
                    ? parseFloat(values.min_gsm, 10)
                    : 0,
                  code: code,
                  machine_code: selectedMachineCode,
                  initital_OrderType: inititalOrderType,
                  is_enabled: isEnabled,
                  body: {
                    ...body,
                    processType: processType,
                    planningType: planningType,
                  },
                  ...((type === "cutting" || processType == "multiStage") && {
                    partitionWeightUnit: form.getFieldValue([
                      "partitionWeightUnit",
                    ])
                      ? form.getFieldValue(["partitionWeightUnit"])
                      : formValues
                      ? formValues.partitionWeightUnit
                      : unitData?.units_management?.weight?.default,
                  }),
                  ...(processType === "multiStage" && {
                    max_NoOfCutters_cutter: maxNoOfCuttersForCutter,
                    left_edge_trim_cutter: leftEdgeTrimForCutter,
                    right_edge_trim_cutter: rightEdgeTrimForCutter,
                  }),
                  processType: processType,
                  // groups: response.data.data.groups.length,
                });
                setPaperMacineData({
                  selected_rewinder: selectedRewinder,
                  selected_cutter: selectedCutter,
                  selected_rewinder_unit: rewinderUnit,
                  selected_cutter_unit: cutterUnit,
                  rewinder_data: allRewinders,
                  cutter_data: allCutters,
                  selected_type: type,
                  rewinder_minWidth: rewinderMinWidth,
                  rewinder_maxWidth: rewinderMaxWidth,
                  cutter_minWidth: cutterMinWidth,
                  cutter_maxWidth: cutterMaxWidth,
                  max_NoOfCutters: maxNoOfCutters,
                  ...((type === "cutting" || processType == "multiStage") && {
                    minWeight: body.min_weight_per_partition,
                  }),
                  rewinder_gsm_wise_configs: values?.gsmWiseWidths,
                  left_edge_trim: leftEdgeTrim,
                  right_edge_trim: rightEdgeTrim,
                  orderResponse: response,
                  maximum_burst_factor: values.max_bf
                    ? parseFloat(values.max_bf, 10)
                    : 0,
                  minimum_burst_factor: values.min_bf
                    ? parseFloat(values.min_bf, 10)
                    : 0,
                  maximum_gsm: values.max_gsm
                    ? parseFloat(values.max_gsm, 10)
                    : 0,
                  minimum_gsm: values.min_gsm
                    ? parseFloat(values.min_gsm, 10)
                    : 0,
                  code: code,
                  machine_code: selectedMachineCode,
                  initital_OrderType: inititalOrderType,
                  is_enabled: isEnabled,
                  body: body,
                  ...((type === "cutting" || processType == "multiStage") && {
                    partitionWeightUnit: form.getFieldValue([
                      "partitionWeightUnit",
                    ])
                      ? form.getFieldValue(["partitionWeightUnit"])
                      : formValues
                      ? formValues.partitionWeightUnit
                      : unitData?.units_management?.weight?.default,
                  }),
                  ...(processType === "multiStage" && {
                    max_NoOfCutters_cutter: maxNoOfCuttersForCutter,
                    left_edge_trim_cutter: leftEdgeTrimForCutter,
                    right_edge_trim_cutter: rightEdgeTrimForCutter,
                  }),
                  processType: processType,
                  // groups: response.data.data.groups.length,
                });
                history("../paper-machine-selected-order", {
                  state: {
                    selected_rewinder: selectedRewinder,
                    selected_cutter: selectedCutter,
                    selected_rewinder_unit: rewinderUnit,
                    selected_cutter_unit: cutterUnit,
                    rewinder_data: allRewinders,
                    cutter_data: allCutters,
                    selected_type: type,
                    rewinder_minWidth: rewinderMinWidth,
                    rewinder_maxWidth: rewinderMaxWidth,
                    cutter_minWidth: cutterMinWidth,
                    cutter_maxWidth: cutterMaxWidth,
                    max_NoOfCutters: maxNoOfCutters,
                    ...((type === "cutting" || processType == "multiStage") && {
                      minWeight: body.min_weight_per_partition,
                    }),
                    left_edge_trim: leftEdgeTrim,
                    right_edge_trim: rightEdgeTrim,
                    rewinder_gsm_wise_configs: values?.gsmWiseWidths,
                    orderResponse: response,
                    maximum_burst_factor: values.max_bf
                      ? parseFloat(values.max_bf, 10)
                      : 0,
                    minimum_burst_factor: values.min_bf
                      ? parseFloat(values.min_bf, 10)
                      : 0,
                    maximum_gsm: values.max_gsm
                      ? parseFloat(values.max_gsm, 10)
                      : 0,
                    minimum_gsm: values.min_gsm
                      ? parseFloat(values.min_gsm, 10)
                      : 0,
                    code: code,
                    machine_code: selectedMachineCode,
                    initital_OrderType: inititalOrderType,
                    is_enabled: isEnabled,
                    body: {
                      ...body,
                      processType: processType,
                      planningType: planningType,
                    },
                    ...((type === "cutting" || processType == "multiStage") && {
                      partitionWeightUnit: form.getFieldValue([
                        "partitionWeightUnit",
                      ])
                        ? form.getFieldValue(["partitionWeightUnit"])
                        : formValues
                        ? formValues.partitionWeightUnit
                        : unitData?.units_management?.weight?.default,
                    }),
                    ...(processType === "multiStage" && {
                      max_NoOfCutters_cutter: maxNoOfCuttersForCutter,
                      left_edge_trim_cutter: leftEdgeTrimForCutter,
                      right_edge_trim_cutter: rightEdgeTrimForCutter,
                    }),
                    processType: processType,
                    // groups: response.data.data.groups.length,
                  },
                });
              } catch (error) {
                setLoadings(false);
                setShowError({
                  error: true,
                  message: error.response?.data?.msg,
                });
              }
            }
          }
        } else {
          setLoadings(true);
          let body = {};
          if (processType == "singleStage") {
            body = {
              ...(type === "rewinding" && 
                { 
                  rewinder_code: code,
                  effective_deckle_length: rewinder[0]?.effective_deckle_length,
                  left_edge_trim: rewinder[0]?.left_edge_trim,
                  right_edge_trim: rewinder[0]?.right_edge_trim,
                  gsm_wise_configs: {
                    [selectedMachineCode]:values?.gsmWiseWidths,
                  },
                }
              ),
              minimum_gsm: machineData[0]?.minimum_gsm,
              maximum_gsm: machineData[0]?.maximum_gsm,
              ...(type === "cutting" && 
                { 
                  cutter_code: code,
                  effective_deckle_length: form.getFieldValue([
                    "effective_deckle_length",
                  ])
                    ? parseFloat(form.getFieldValue(["effective_deckle_length"]))
                    : location.state?.body.effective_deckle_length
                    ? parseFloat(location.state?.body.effective_deckle_length)
                    : null,
                  left_edge_trim: parseFloat(form.getFieldValue(["min_width"]), 10),
                  right_edge_trim: parseFloat(form.getFieldValue(["max_width"]),10),
                }
              ),
              machine_type: type === "rewinding" ? "rewinder" : "cutter",
              maximum_cutters: parseFloat(form.getFieldValue(["cutters"]), 10),
              ...(type === "cutting" && {
                min_weight_per_partition: form.getFieldValue([
                  "min_weight_per_partition",
                ])
                  ? parseFloat(form.getFieldValue(["min_weight_per_partition"]))
                  : 0,
              }),
              units: {
                ...(type === "cutting" && {
                left_edge_trim: form.getFieldValue(["Unit"])
                  ? form.getFieldValue(["Unit"])
                  : formValues
                  ? formValues.Unit
                  : unitData?.units_management?.length.default,
                right_edge_trim: form.getFieldValue(["Unit"])
                  ? form.getFieldValue(["Unit"])
                  : formValues
                  ? formValues.Unit
                  : unitData?.units_management?.length.default,
                effective_deckle_length: form.getFieldValue(["Unit"])
                  ? form.getFieldValue(["Unit"])
                  : formValues
                  ? formValues.Unit
                  : unitData?.units_management?.length.default,
                
                  min_weight_per_partition: form.getFieldValue([
                    "partitionWeightUnit",
                  ])
                    ? form.getFieldValue(["partitionWeightUnit"])
                    : formValues
                    ? formValues.partitionWeightUnit
                    : unitData?.units_management?.weight?.default,
                }),
                ...(type === "rewinding" && {
                  gsm_wise_configs:{
                    [selectedMachineCode]:rewinder[0]?.units?.gsm_wise_configs[selectedMachineCode]
                  }
                })
              },
              move_to_selected_orders: [],
            };
          } else {
            body = {
              //machine_code: selectedMachineCode,
              // grades_and_qualities: selectedGQ,
              //minimum_gsm: parseFloat(values.min_gsm, 10),
              // maximum_gsm: parseFloat(values.max_gsm, 10),
              //order_window: parseFloat(values.order_window, 10),
              //order_type: values.order_type,

              machine_data: [
                {
                  rewinder_code: allRewinders?.find(
                    (cutter) => cutter?.name === selectedRewinder
                  )?.code,
                  machine_type: "rewinder",
                  gsm_wise_configs: {
                    [selectedMachineCode]: values.gsmWiseWidths,
                  },
                  maximum_cutters: parseFloat(
                    form.getFieldValue(["cutters"]),
                    10
                  ),
                  units: rewinder[0]?.units,
                },
                {
                  cutter_code: allCutters?.find(
                    (cutter) => cutter?.name === selectedCutter
                  )?.code,
                  machine_type: "cutter",
                  effective_deckle_length: form.getFieldValue([
                    "effective_deckle_length_cutter",
                  ])
                    ? parseFloat(
                        form.getFieldValue(["effective_deckle_length_cutter"])
                      )
                    : location.state?.body.machine_data[1]
                        ?.effective_deckle_length
                    ? parseFloat(
                        location.state?.body.machine_data[1]
                          ?.effective_deckle_length
                      )
                    : null,
                  left_edge_trim: parseFloat(
                    form.getFieldValue(["min_width_cutter"]),
                    10
                  ),
                  right_edge_trim: parseFloat(
                    form.getFieldValue(["max_width_cutter"]),
                    10
                  ),
                  maximum_cutters: parseFloat(
                    form.getFieldValue(["cutters_cutter"]),
                    10
                  ),
                  minimum_chop_size: parseFloat(
                    form.getFieldValue(["min_chop"]),
                    10
                  ),
                  maximum_chop_size: parseFloat(
                    form.getFieldValue(["max_chop"]),
                    10
                  ),
                  minimum_reel_dia: parseFloat(
                    form.getFieldValue(["min_dia"]),
                    10
                  ),
                  maximum_reel_dia: parseFloat(
                    form.getFieldValue(["max_dia"]),
                    10
                  ),
                  allowed_trim: parseFloat(
                    form.getFieldValue(["max_trim"]),
                    10
                  ),
                  //min_weight_per_partition : form.getFieldValue(['min_weight_per_partition']) ? form.getFieldValue(['min_weight_per_partition']) : formValues ? formValues.partitionWeightUnit : unitData?.units_management?.weight?.default,
                  units: {
                    left_edge_trim: form.getFieldValue(["unit_cutter"])
                      ? form.getFieldValue(["unit_cutter"])
                      : formValues
                      ? formValues.unit_cutter
                      : unitData?.units_management?.length.default,
                    right_edge_trim: form.getFieldValue(["unit_cutter"])
                      ? form.getFieldValue(["unit_cutter"])
                      : formValues
                      ? formValues.unit_cutter
                      : unitData?.units_management?.length.default,
                    effective_deckle_length: form.getFieldValue(["unit_cutter"])
                      ? form.getFieldValue(["unit_cutter"])
                      : formValues
                      ? formValues.unit_cutter
                      : unitData?.units_management?.length.default,
                    //min_weight_per_partition : form.getFieldValue(['partitionWeightUnit']) ? form.getFieldValue(['partitionWeightUnit']) : formValues ? formValues.partitionWeightUnit : unitData?.units_management?.weight?.default,
                    allowed_trim: form.getFieldValue(["trim_unit"]),
                    minimum_chop_size: form.getFieldValue(["chop_unit"]),
                    maximum_chop_size: form.getFieldValue(["chop_unit"]),
                    minimum_reel_dia: form.getFieldValue(["dia_unit"]),
                    maximum_reel_dia: form.getFieldValue(["dia_unit"]),
                  },
                },
              ],
            };
          }

          const formData = {
            ...body,
            // effective_deckle_length: form.getFieldValue([
            //   "effective_deckle_length",
            // ])
            //   ? parseFloat(form.getFieldValue(["effective_deckle_length"]))
            //   : location.state?.body.effective_deckle_length
            //   ? parseFloat(location.state?.body.effective_deckle_length)
            //   : null,
            machine_code: selectedMachineCode,
            grade: selectedGrade,
            min_deckle_length: getPaperMachineList.minimum_width,
            max_deckle_length: getPaperMachineList.maximum_width,
            selectedCustomerList: selectedCustomerList,
            product_parameters: productParameters,
            order_types: updatedOrderTypeOptions,
            planning_type: values.planning_type,
            Unit: form.getFieldValue(["Unit"])
              ? form.getFieldValue(["Unit"])
              : formValues
              ? formValues.Unit
              : unitData?.units_management?.length.default,
            partitionWeightUnit: form.getFieldValue(["partitionWeightUnit"])
              ? form.getFieldValue(["partitionWeightUnit"])
              : formValues
              ? formValues.partitionWeightUnit
              : unitData?.units_management?.weight?.default,
            unit_cutter: form.getFieldValue(["unit_cutter"])
              ? form.getFieldValue(["unit_cutter"])
              : formValues
              ? formValues.unit_cutter
              : unitData?.units_management?.length.default,
            processType: processType,
            order_type: inititalOrderType,
          };

          try {
            let response;
            if (processType == "singleStage") {
              response = await getDeckleMachineOrders(body);
            }
            if (processType == "multiStage") {
              response = await getDeckleMachineOrdersForMultiStage(body);
            }
            setShowError({
              error: false,
            });
            // console.log("number of groups", response.data.data.groups.length);
            setFormObject(formData);
            setPaperMachineCheckedBoxId(null);
            setPaperMachineOrdersData({
              body: {
                ...body,
                processType: processType,
                planningType: planningType,
              },
              data: response.data.data,
              maximum_burst_factor: values.max_bf
                ? parseFloat(values.max_bf, 10)
                : 0,
              minimum_burst_factor: values.min_bf
                ? parseFloat(values.min_bf, 10)
                : 0,
              maximum_gsm: values.max_gsm ? parseFloat(values.max_gsm, 10) : 0,
              minimum_gsm: values.min_gsm ? parseFloat(values.min_gsm, 10) : 0,
              machine_code: selectedMachineCode,
              selected_rewinder: selectedRewinder,
              selected_rewinder_unit: rewinderUnit,
              selected_cutter: selectedCutter,
              selected_cutter_unit: cutterUnit,
              rewinder_data: allRewinders,
              rewinder_data: allRewinders,
              cutter_data: allCutters,
              selected_type: type,
              rewinder_minWidth: rewinderMinWidth,
              rewinder_maxWidth: rewinderMaxWidth,
              cutter_minWidth: cutterMinWidth,
              cutter_maxWidth: cutterMaxWidth,
              max_NoOfCutters: maxNoOfCutters,
              ...(type === "cutting" && {
                minWeight: body.min_weight_per_partition,
              }),
              rewinder_gsm_wise_configs: values?.gsmWiseWidths,
              left_edge_trim: leftEdgeTrim,
              right_edge_trim: rightEdgeTrim,
              code: code,
              initital_OrderType: inititalOrderType,
              is_enabled: isEnabled,
              ...(type === "cutting" && {
                partitionWeightUnit: form.getFieldValue(["partitionWeightUnit"])
                  ? form.getFieldValue(["partitionWeightUnit"])
                  : formValues
                  ? formValues.partitionWeightUnit
                  : unitData?.units_management?.weight?.default,
              }),
              // groups: response.data.data.groups.length,
              ...(processType === "multiStage" && {
                max_NoOfCutters_cutter: maxNoOfCuttersForCutter,
                left_edge_trim_cutter: leftEdgeTrimForCutter,
                right_edge_trim_cutter: rightEdgeTrimForCutter,
              }),
              processType: processType,
            });
            setPaperMacineData({
              body: body,
              data: response.data.data,
              maximum_burst_factor: values.max_bf
                ? parseFloat(values.max_bf, 10)
                : 0,
              minimum_burst_factor: values.min_bf
                ? parseFloat(values.min_bf, 10)
                : 0,
              maximum_gsm: values.max_gsm ? parseFloat(values.max_gsm, 10) : 0,
              minimum_gsm: values.min_gsm ? parseFloat(values.min_gsm, 10) : 0,
              machine_code: selectedMachineCode,
              selected_rewinder: selectedRewinder,
              selected_rewinder_unit: rewinderUnit,
              selected_cutter: selectedCutter,
              selected_cutter_unit: cutterUnit,
              rewinder_data: allRewinders,
              rewinder_data: allRewinders,
              cutter_data: allCutters,
              selected_type: type,
              rewinder_minWidth: rewinderMinWidth,
              rewinder_maxWidth: rewinderMaxWidth,
              cutter_minWidth: cutterMinWidth,
              cutter_maxWidth: cutterMaxWidth,
              max_NoOfCutters: maxNoOfCutters,
              ...(type === "cutting" && {
                minWeight: body.min_weight_per_partition,
              }),
              rewinder_gsm_wise_configs: values?.gsmWiseWidths,
              left_edge_trim: leftEdgeTrim,
              right_edge_trim: rightEdgeTrim,
              code: code,
              initital_OrderType: inititalOrderType,
              is_enabled: isEnabled,
              ...(type === "cutting" && {
                partitionWeightUnit: form.getFieldValue(["partitionWeightUnit"])
                  ? form.getFieldValue(["partitionWeightUnit"])
                  : formValues
                  ? formValues.partitionWeightUnit
                  : unitData?.units_management?.weight?.default,
              }),
              // groups: response.data.data.groups.length,
              ...(processType === "multiStage" && {
                max_NoOfCutters_cutter: maxNoOfCuttersForCutter,
                left_edge_trim_cutter: leftEdgeTrimForCutter,
                right_edge_trim_cutter: rightEdgeTrimForCutter,
              }),
              processType: processType,
            });
            history("../paper-machine-orders", {
              state: {
                body: {
                  ...body,
                  processType: processType,
                  planningType: planningType,
                },
                data: response.data.data,
                maximum_burst_factor: values.max_bf
                  ? parseFloat(values.max_bf, 10)
                  : 0,
                minimum_burst_factor: values.min_bf
                  ? parseFloat(values.min_bf, 10)
                  : 0,
                maximum_gsm: values.max_gsm
                  ? parseFloat(values.max_gsm, 10)
                  : 0,
                minimum_gsm: values.min_gsm
                  ? parseFloat(values.min_gsm, 10)
                  : 0,
                machine_code: selectedMachineCode,
                selected_rewinder: selectedRewinder,
                selected_rewinder_unit: rewinderUnit,
                selected_cutter: selectedCutter,
                selected_cutter_unit: cutterUnit,
                rewinder_data: allRewinders,
                rewinder_data: allRewinders,
                cutter_data: allCutters,
                selected_type: type,
                rewinder_minWidth: rewinderMinWidth,
                rewinder_maxWidth: rewinderMaxWidth,
                cutter_minWidth: cutterMinWidth,
                cutter_maxWidth: cutterMaxWidth,
                rewinder_gsm_wise_configs: values?.gsmWiseWidths,
                max_NoOfCutters: maxNoOfCutters,
                ...(type === "cutting" && {
                  minWeight: body.min_weight_per_partition,
                }),
                left_edge_trim: leftEdgeTrim,
                right_edge_trim: rightEdgeTrim,
                code: code,
                initital_OrderType: inititalOrderType,
                is_enabled: isEnabled,
                ...(type === "cutting" && {
                  partitionWeightUnit: form.getFieldValue([
                    "partitionWeightUnit",
                  ])
                    ? form.getFieldValue(["partitionWeightUnit"])
                    : formValues
                    ? formValues.partitionWeightUnit
                    : unitData?.units_management?.weight?.default,
                }),
                // groups: response.data.data.groups.length,
                ...(processType === "multiStage" && {
                  max_NoOfCutters_cutter: maxNoOfCuttersForCutter,
                  left_edge_trim_cutter: leftEdgeTrimForCutter,
                  right_edge_trim_cutter: rightEdgeTrimForCutter,
                }),
                processType: processType,
              },
            });
          } catch (error) {
            setLoadings(false);
            setShowError({
              error: true,
              message: error.response?.data?.msg,
            });
          }
        }
      }
    }
  };

  const changeDeckleLength = () => {
    // const unit = form.getFieldValue("Unit");
    // const result =
    //   unit == "cm"
    //     ? getPaperMachineList.maximum_width -
    //       form.getFieldValue("min_width") -
    //       form.getFieldValue("max_width")
    //     : unit == "mm"
    //     ? getPaperMachineList.maximum_width -
    //       form.getFieldValue("min_width") / 10 -
    //       form.getFieldValue("max_width") / 10
    //     : "";
    // if (result < 0) {
    //   form.setFieldsValue({
    //     min_width: "",
    //     max_width: "",
    //     effective_deckle_length: "",
    //   });
    //   setShowError({
    //     error: true,
    //     message: `Total edge trim cannot be greater than deckle width`,
    //   });
    // } else {
    //   setShowError({
    //     error: false,
    //   });
    //   form.setFieldsValue({ effective_deckle_length: result.toFixed(2) });
    // }
    edgeTrimValidation();
  };

  const handleRewindingCuttingChange = (e) => {
    setType(e.target.value);
    setSelectedGrade();
    setSelectedGQ([]);
    setSelected([]);
    setMaxNoOfCutters();
    setLeftEdgeTrim();
    setRightEdgeTrim();
    setMaxNoOfCuttersForCutter();
    setLeftEdgeTrimForCutter();
    setRightEdgeTrimForCutter();
    setCode();
    setSelectedCutter();
    setCutterMinWidth();
    setCutterMaxWidth();
    setCutterUnit();
    setCutterUnits();
    setSelectedRewinder();
    setRewinderMinWidth();
    setRewinderMaxWidth();
    setRewinderUnit();
    setEnabled(false);
    setIsGSMError(false);
    setIsIDiaError(false);
    form.setFieldsValue({
      min_width: "",
      max_width: "",
      cutters: "",
      grade: null,
      quality: "",
    });
    if (processType == "multiStage") {
      form.setFieldsValue({
        min_width_cutter: "",
        max_width_cutter: "",
        cutters_cutter: "",
        grade: null,
        quality: "",
      });
    }
    if (e.target.value === "cutting" && processType == "multiStage") {
      setOrderType("sheet");
      form.setFieldsValue({ order_type: "sheet" });
      setEnabled(true);
    } else {
      setOrderType("reel");
      form.setFieldsValue({ order_type: "both" });
      setEnabled(false);
    }
  };

  const onRewinderChange = (e) => {
    setLeftEdgeTrim();
    setRightEdgeTrim();
    setMaxNoOfCutters();
    setSelectedRewinder(e);
    let selectedRewinder = allRewinders?.filter(
      (rewinder) => rewinder?.name?.toLowerCase() === e?.toLowerCase()
    );
    setRewinderMinWidth(selectedRewinder[0]?.minimum_width);
    setRewinderMaxWidth(selectedRewinder[0]?.maximum_width);
    form.setFieldsValue({ cutters: selectedRewinder[0]?.maximum_cutters });
    setMaxNoOfCutters(selectedRewinder[0]?.maximum_cutters);
    form.setFieldsValue({ min_width: selectedRewinder[0]?.left_edge_trim });
    setLeftEdgeTrim(selectedRewinder[0]?.left_edge_trim);
    form.setFieldsValue({ max_width: selectedRewinder[0]?.right_edge_trim });
    setRightEdgeTrim(selectedRewinder[0]?.right_edge_trim);
    setCode(selectedRewinder[0]?.code);
    setRewinderUnit(
      lengthUnit[
        selectedRewinder[0].units?.maximum_width
      ]?.displayName.toUpperCase()
    );
    let gsm_wise_configs=[];
    if(Object.keys(selectedRewinder[0]?.gsm_wise_configs).length)
    {
      gsm_wise_configs = selectedRewinder[0]?.gsm_wise_configs[selectedMachineCode];
    }
    else{
      gsm_wise_configs = [
        {
          min_gsm: selectedRewinder[0]?.minimum_gsm,
          max_gsm: selectedRewinder[0]?.maximum_gsm,
          min_deckle_width: selectedRewinder[0]?.minimum_width,
          max_deckle_width: selectedRewinder[0]?.maximum_width,
          effective_deckle_length: selectedRewinder[0]?.effective_deckle_length,
          left_edge_trim: selectedRewinder[0]?.left_edge_trim,
          right_edge_trim: selectedRewinder[0]?.right_edge_trim,
          max_allowed_trim_loss_percentage: selectedRewinder[0]?.maximum_loss,
        }
      ]
    }
    form.setFieldsValue({"gsmWiseWidths":gsm_wise_configs});

    if(isDummyJC)
    {
      disabledNext.current = false;
    }
  };

  const onCutterChange = (e) => {
    if (processType == "multiStage") {
      setLeftEdgeTrimForCutter();
      setRightEdgeTrimForCutter();
      setMaxNoOfCuttersForCutter();
      setSelectedCutter(e);
      let selectedCutter = allCutters?.filter(
        (cutter) => cutter?.name?.toLowerCase() === e?.toLowerCase()
      );
      setCutterMinWidth(selectedCutter[0]?.minimum_width);
      setCutterMaxWidth(selectedCutter[0]?.maximum_width);
      form.setFieldsValue({
        cutters_cutter: selectedCutter[0]?.maximum_cutters,
      });
      setMaxNoOfCuttersForCutter(selectedCutter[0]?.maximum_cutters);
      form.setFieldsValue({
        min_width_cutter: selectedCutter[0]?.left_edge_trim,
      });
      setLeftEdgeTrimForCutter(selectedCutter[0]?.left_edge_trim);
      form.setFieldsValue({
        max_width_cutter: selectedCutter[0]?.right_edge_trim,
      });
      setRightEdgeTrimForCutter(selectedCutter[0]?.right_edge_trim);
      setCode(selectedCutter[0]?.code);
      setCutterUnit(
        lengthUnit[
          selectedCutter[0]?.units?.maximum_width
        ].displayName.toUpperCase()
      );
      setCutterUnits(selectedCutter[0]?.units)
    } else {
      setLeftEdgeTrim();
      setRightEdgeTrim();
      setMaxNoOfCutters();
      setSelectedCutter(e);
      let selectedCutter = allCutters?.filter(
        (cutter) => cutter?.name?.toLowerCase() === e?.toLowerCase()
      );
      setCutterMinWidth(selectedCutter[0]?.minimum_width);
      setCutterMaxWidth(selectedCutter[0]?.maximum_width);
      form.setFieldsValue({ cutters: selectedCutter[0]?.maximum_cutters });
      setMaxNoOfCutters(selectedCutter[0]?.maximum_cutters);
      form.setFieldsValue({ min_width: selectedCutter[0]?.left_edge_trim });
      setLeftEdgeTrim(selectedCutter[0]?.left_edge_trim);
      form.setFieldsValue({ max_width: selectedCutter[0]?.right_edge_trim });
      setRightEdgeTrim(selectedCutter[0]?.right_edge_trim);
      setCode(selectedCutter[0]?.code);
      setCutterUnit(
        lengthUnit[
          selectedCutter[0]?.units?.maximum_width
        ].displayName.toUpperCase()
      );
      setCutterUnits(selectedCutter[0]?.units)
    }
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const edgeTrimValidation = async () => {
    await sleep(20);
    if (
      (processType == "singleStage" && (selectedRewinder || selectedCutter)) ||
      (processType == "multiStage" && selectedRewinder && selectedCutter)
    ) {
      if (processType == "singleStage" && type === "rewinding") {
        if (selectedRewinder) {
          let filteredRewinder = allRewinders?.find(
            (rewinder) =>
              rewinder?.name?.toLowerCase() === selectedRewinder?.toLowerCase()
          );

          if (
            parseFloat(
              form.getFieldValue("min_width") *
                CoversionFactorUnitsToCM[form.getFieldValue("Unit")]
            ) +
              parseFloat(
                form.getFieldValue("max_width") *
                  CoversionFactorUnitsToCM[form.getFieldValue("Unit")]
              ) >=
            (rewinderMaxWidth - rewinderMinWidth) *
              CoversionFactorUnitsToCM[filteredRewinder.units.maximum_width]
          ) {
            form.setFieldsValue({
              min_width: "",
              max_width: "",
              effective_deckle_length: "",
            });

            setShowError({
              error: true,
              message: `Total edge trim should be less than difference of deckle range.`,
            });
            setTimeout(() => {
              setShowError({
                error: false,
              });
            }, 3000);
          } else {
            let unit = form.getFieldValue("Unit")
              ? form.getFieldValue("Unit")
              : unitData?.units_management?.length.default;
            let effeDeckleLen =
              rewinderMaxWidth *
                CoversionFactorUnitsToCM[filteredRewinder.units.maximum_width] -
              (parseFloat(form.getFieldValue("min_width")) +
                parseFloat(form.getFieldValue("max_width"))) *
                CoversionFactorUnitsToCM[unit];
            setShowError({
              error: false,
            });

            form.setFieldsValue({
              effective_deckle_length: isNaN(effeDeckleLen)
                ? ""
                : (effeDeckleLen * CoversionFactorCMToUnits[unit])?.toFixed(2),
            });
          }
        } else {
          form.setFieldsValue({ effective_deckle_length: "" });
        }
      } else {
        if (selectedCutter && processType == "singleStage") {
          let filteredCutter = allCutters?.find(
            (cutter) =>
              cutter?.name?.toLowerCase() === selectedCutter?.toLowerCase()
          );
          if (
            parseFloat(
              form.getFieldValue("min_width") *
                CoversionFactorUnitsToCM[form.getFieldValue("Unit")]
            ) +
              parseFloat(
                form.getFieldValue("max_width") *
                  CoversionFactorUnitsToCM[form.getFieldValue("Unit")]
              ) >=
            (cutterMaxWidth - cutterMinWidth) *
              CoversionFactorUnitsToCM[filteredCutter.units.maximum_width]
          ) {
            form.setFieldsValue({
              min_width: "",
              max_width: "",
              effective_deckle_length: "",
            });
            setShowError({
              error: true,
              message: `Total edge trim should be less than difference of deckle range.`,
            });
            setTimeout(() => {
              setShowError({
                error: false,
              });
            }, 3000);
          } else {
            let unit = form.getFieldValue("Unit")
              ? form.getFieldValue("Unit")
              : unitData?.units_management?.length.default;

            let effeDeckleLen =
              cutterMaxWidth *
                CoversionFactorUnitsToCM[filteredCutter.units.maximum_width] -
              (parseFloat(form.getFieldValue("min_width")) +
                parseFloat(form.getFieldValue("max_width"))) *
                CoversionFactorUnitsToCM[unit];
            setShowError({
              error: false,
            });
            form.setFieldsValue({
              effective_deckle_length: isNaN(effeDeckleLen)
                ? ""
                : (effeDeckleLen * CoversionFactorCMToUnits[unit])?.toFixed(2),
            });
          }
        } else if (selectedCutter) {
          if (selectedRewinder) {
            let filteredRewinder = allRewinders?.find(
              (rewinder) =>
                rewinder?.name?.toLowerCase() ===
                selectedRewinder?.toLowerCase()
            );

            if (
              parseFloat(
                form.getFieldValue("min_width") *
                  CoversionFactorUnitsToCM[form.getFieldValue("Unit")]
              ) +
                parseFloat(
                  form.getFieldValue("max_width") *
                    CoversionFactorUnitsToCM[form.getFieldValue("Unit")]
                ) >=
              (rewinderMaxWidth - rewinderMinWidth) *
                CoversionFactorUnitsToCM[filteredRewinder.units.maximum_width]
            ) {
              form.setFieldsValue({
                min_width: "",
                max_width: "",
                effective_deckle_length: "",
              });

              setShowError({
                error: true,
                message: `Total edge trim should be less than difference of deckle range.`,
              });
              setTimeout(() => {
                setShowError({
                  error: false,
                });
              }, 3000);
            } else {
              let unit = form.getFieldValue("Unit")
                ? form.getFieldValue("Unit")
                : unitData?.units_management?.length.default;
              let effeDeckleLen =
                rewinderMaxWidth *
                  CoversionFactorUnitsToCM[
                    filteredRewinder.units.maximum_width
                  ] -
                (parseFloat(form.getFieldValue("min_width")) +
                  parseFloat(form.getFieldValue("max_width"))) *
                  CoversionFactorUnitsToCM[unit];
              setShowError({
                error: false,
              });

              form.setFieldsValue({
                effective_deckle_length: isNaN(effeDeckleLen)
                  ? ""
                  : (effeDeckleLen * CoversionFactorCMToUnits[unit])?.toFixed(
                      2
                    ),
              });
            }
          } else {
            form.setFieldsValue({ effective_deckle_length: "" });
          }

          let filteredCutter = allCutters?.find(
            (cutter) =>
              cutter?.name?.toLowerCase() === selectedCutter?.toLowerCase()
          );
          if (
            parseFloat(
              form.getFieldValue("min_width_cutter") *
                CoversionFactorUnitsToCM[form.getFieldValue("unit_cutter")]
            ) +
              parseFloat(
                form.getFieldValue("max_width_cutter") *
                  CoversionFactorUnitsToCM[form.getFieldValue("unit_cutter")]
              ) >=
            (cutterMaxWidth - cutterMinWidth) *
              CoversionFactorUnitsToCM[filteredCutter.units.maximum_width]
          ) {
            form.setFieldsValue({
              min_width_cutter: "",
              max_width_cutter: "",
              effective_deckle_length_cutter: "",
            });
            setShowError({
              error: true,
              message: `Total edge trim should be less than difference of deckle range.`,
            });
            setTimeout(() => {
              setShowError({
                error: false,
              });
            }, 3000);
          } else {
            let unit = form.getFieldValue("unit_cutter")
              ? form.getFieldValue("unit_cutter")
              : unitData?.units_management?.length.default;

            let effeDeckleLen =
              cutterMaxWidth *
                CoversionFactorUnitsToCM[filteredCutter.units.maximum_width] -
              (parseFloat(form.getFieldValue("min_width_cutter")) +
                parseFloat(form.getFieldValue("max_width_cutter"))) *
                CoversionFactorUnitsToCM[unit];
            setShowError({
              error: false,
            });
            form.setFieldsValue({
              effective_deckle_length_cutter: isNaN(effeDeckleLen)
                ? ""
                : (effeDeckleLen * CoversionFactorCMToUnits[unit])?.toFixed(2),
            });
          }
        } else {
          form.setFieldsValue({ effective_deckle_length_cutter: "" });
        }
      }
    } else {
      if (processType == "singleStage") {
        let deckleWidth =
          type === "rewinding"
            ? rewinderMaxWidth - rewinderMinWidth
            : cutterMaxWidth - cutterMinWidth;
        if (
          (form.getFieldValue("min_width") ||
            form.getFieldValue("max_width")) >= deckleWidth
        ) {
          form.setFieldsValue({ effective_deckle_length: "" });
        }
      } else {
        let deckleWidthRewinder = rewinderMaxWidth - rewinderMinWidth;
        if (
          (form.getFieldValue("min_width") ||
            form.getFieldValue("max_width")) >= deckleWidthRewinder
        ) {
          form.setFieldsValue({ effective_deckle_length: "" });
        }
        let deckleWidthCutter = cutterMaxWidth - cutterMinWidth;
        if (
          (form.getFieldValue("min_width_cutter") ||
            form.getFieldValue("max_width_cutter")) >= deckleWidthCutter
        ) {
          form.setFieldsValue({ effective_deckle_length_cutter: "" });
        }
      }
    }
  };
// useEffect(()=>{
//   cancelJobCard();
// },[])
  return (
    !isLoading &&
    grades &&
    globalSettings && (
      <RightLayoutContainer>
        <PageTitleComp>
          <PageHeader
            ghost={false}
            title="Select Paper Machine"
            extra={[
              <PaperHeaderButtonStyle>
                <Button
                  key="3"
                  className="textTypeBtn textBtnIcon paperButtonBg"
                  onClick={() => {
                    setPaperMachineCheckedBoxId(null);
                    setFormObject(null);
                    history("../job-cards");
                  }}
                >
                  <Iconmoon icon="wrong" size={14} color="#EA655B" />
                  Cancel Job Card
                </Button>
                {/* {console.log(disabledNext)} */}
                {disabledNext.current ? (
                  <Button className="themeBtn noBg paperButtonnoBg disabled">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="10" cy="10" r="9.5" stroke="#A19F9D " />
                    </svg>
                    Next
                  </Button>
                ) : (
                  <Button
                    key="1"
                    className="themeBtn"
                    onClick={routeChange}
                    loading={loadings}
                  >
                    {!loadings && (
                      <Iconmoon icon="move-right" size={14} color="#ffffff" />
                    )}
                    {!loadings ? "Next" : ""}
                  </Button>
                )}
              </PaperHeaderButtonStyle>,
            ]}
          ></PageHeader>
        </PageTitleComp>
        <AlertDiv>
          <div>
            {/* Error toaster */}
            {showError.error ? (
              <AlertContainer
                color="red"
                icon={alertRed}
                msg={`${capitalize(showError.message)}`}
                style={{ marginTop: "35px" }}
              />
            ) : (
              <></>
            )}
          </div>
        </AlertDiv>
        <Layout style={{ backgroundColor: "#ffffff", paddingTop: "11px" }}>
          <Row span={24}>
            <Col span={8}>
              <PaperMachineRecordsData>
                <div className="ListingPaperCovers">
                  <ProcessTypeStyle>
                    {/* <div className="rewindingCuttingBoxStyle"> */}
                    <div
                      className=" switchRadio twoSwitch"
                      style={{
                        justifyContent: "center",
                        paddingBottom: "20px",
                        background: "white",
                      }}
                    >
                      <Radio.Group
                        onChange={handleProcessTypeChange}
                        value={processType}
                        options={convertingProcessTabArray}
                        optionType="button"
                        buttonStyle="solid"
                        disabled = {isDummyJC}
                      />
                    </div>
                  </ProcessTypeStyle>
                  {/* </div> */}
                  <div className="leftListingPapeprMachines">
                    <span>Paper Machines</span>
                  </div>
                  <PaperMachineScroll id="scrollBox">
                    <SimpleBar className="cardRollers">
                      {paperMachineList && paperMachineList.length
                        ? paperMachineList.map((eachItem) => {
                            return (
                              <div id="rewinderDropdown">
                                <div
                                  className={
                                    paperMachineCheckedBoxId === eachItem.code
                                      ? "checkboxListingPapers checkboxListingPapers-active"
                                      : "checkboxListingPapers"
                                  }
                                  onClick={() => {
                                    setMachineOrderType(eachItem);
                                    setFormValues();
                                    disabledNext.current = true;
                                    setDisableButton(true);
                                    setPlanningType(isDummyJC ? 'purchaseOrder' :  "quality");
                                    setPaperMachineCheckedBoxId(eachItem.code);
                                    setGetPaperMachineList(eachItem);
                                    setShowError({
                                      error: false,
                                      message: "",
                                    });
                                    setSelected([]);
                                    setSelectedGQ([]);
                                    setSelectedGrade();
                                    setSelectedCustomer([]);
                                    setSelectedCustomerList([]);
                                    setProductParameters([]);
                                    setShowBFRange(false);
                                    setShowMoisture(false);
                                    form.setFieldsValue({
                                      min_bf: "",
                                      max_bf: "",
                                    });
                                    form.setFieldsValue({
                                      min_moisture: "",
                                      max_moisture: "",
                                    });
                                  }}
                                >
                                  <div className="rightBoxImage">
                                    <img
                                      src={PaperMachine}
                                      alt="Paper Machine"
                                    />
                                  </div>
                                  <div className="rightBoxTitle">
                                    <span>{eachItem.name}</span>
                                    <p>
                                      {eachItem.order_type === "both"
                                        ? "Reel & Sheet Orders"
                                        : capitalize(eachItem.order_type) +
                                          " Orders"}
                                    </p>
                                    <p>
                                      GSM : {eachItem.minimum_gsm} -{" "}
                                      {eachItem.maximum_gsm}
                                    </p>
                                    <p>
                                      Deckle :{" "}
                                      {eachItem.minimum_width.toFixed(3)} -{" "}
                                      {eachItem.maximum_width.toFixed(3)}{" "}
                                      {eachItem.units.maximum_width}
                                    </p>
                                  </div>
                                  <Checkbox
                                    type="checkbox"
                                    checked={
                                      paperMachineCheckedBoxId === eachItem.code
                                        ? true
                                        : false
                                    }
                                    ref={
                                      paperMachineCheckedBoxId === eachItem.code
                                        ? scrollPositionsRef
                                        : null
                                    }
                                  />
                                </div>
                                {paperMachineCheckedBoxId ===
                                  eachItem?.code && (
                                  <div>
                                    <div className="rewindingCuttingBoxStyle">
                                      {processType == "singleStage" && (
                                        <div
                                          className=" switchRadio twoSwitch"
                                          style={{ justifyContent: "center" }}
                                        >
                                          <Radio.Group
                                            options={rewindingCuttingTabArray}
                                            optionType="button"
                                            buttonStyle="solid"
                                            value={type}
                                            disabled={
                                              eachItem?.order_type !== "both" || isDummyJC
                                            }
                                            onChange={
                                              handleRewindingCuttingChange
                                            }
                                          />
                                        </div>
                                      )}
                                      {((type === "rewinding" &&
                                        processType == "singleStage") ||
                                        processType == "multiStage") && (
                                        <div
                                          style={{
                                            marginTop: "4px",
                                            marginBottom: "-44px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginBottom: "3px",
                                              marginLeft: "-156px",
                                              fontSize: "13px",
                                            }}
                                          >
                                            <label>Select Rewinder:</label>
                                          </div>
                                          <DetailFields>
                                            <HaberForm>
                                              <Row
                                                style={{
                                                  width: "100%",
                                                  textAlign: "left",
                                                }}
                                              >
                                                <Select
                                                  listHeight={150}
                                                  getPopupContainer={(
                                                    trigger
                                                  ) =>
                                                    document.getElementById(
                                                      "rewinderDropdown"
                                                    )
                                                  }
                                                  style={{ width: "100%" }}
                                                  placeholder="Select Rewinder"
                                                  suffixIcon={
                                                    isRewinderDropdownOpen ? (
                                                      <DropDownSearchDraw />
                                                    ) : (
                                                      <DownArrowDraw />
                                                    )
                                                  }
                                                  onBlur={
                                                    OnRewindertoggleSelect
                                                  }
                                                  onFocus={
                                                    OnRewindertoggleSelect
                                                  }
                                                  showSearch={
                                                    allRewinders &&
                                                    allRewinders.length
                                                  }
                                                  optionFilterProp="children"
                                                  filterOption={(
                                                    input,
                                                    option
                                                  ) =>
                                                    option?.key
                                                      ?.toString()
                                                      .toLowerCase()
                                                      .includes(
                                                        input.toLowerCase()
                                                      )
                                                  }
                                                  value={selectedRewinder}
                                                  onChange={(e) => {
                                                    onRewinderChange(e);
                                                  }}
                                                >
                                                  {allRewinders &&
                                                  allRewinders.length ? (
                                                    allRewinders?.map(
                                                      (rewinder) => (
                                                        <Option
                                                          key={rewinder?.name}
                                                        >
                                                          <p
                                                            style={{
                                                              textAlign: "left",
                                                              marginBottom:
                                                                "0px",
                                                            }}
                                                          >
                                                            {rewinder?.name}
                                                          </p>
                                                          
                                                          {rewinder?.maximum_width && rewinder?.minimum_width && rewinder?.units?.maximum_width?<><br /><p
                                                            style={{
                                                              fontSize: "10px",
                                                              textAlign: "left",
                                                              marginTop:
                                                                "-22px",
                                                              marginBottom:
                                                                "0px",
                                                              color:
                                                                "rgba(0, 0, 0, 0.85)",
                                                              lineHeight:
                                                                "22px",
                                                            }}
                                                          >
                                                            {"Deckle: "}
                                                            {+rewinder?.minimum_width +
                                                              " - " +
                                                              rewinder?.maximum_width +
                                                              " " +
                                                              capitalize(
                                                                rewinder?.units
                                                                  ?.minimum_width
                                                              )}
                                                          </p></>:<></>}
                                                        </Option>
                                                      )
                                                    )
                                                  ) : allRewinders ? (
                                                    <Select.Option
                                                      value="loading"
                                                      disabled
                                                    >
                                                      <CardShimmerStyle>
                                                        {/* <Skeleton active paragraph={{ rows: 1 }} />
                                              <Skeleton active paragraph={{ rows: 1 }} />
                                              <Skeleton active paragraph={{ rows: 1 }} /> */}
                                                        <p
                                                          style={{
                                                            paddingTop: "20px",
                                                            minHeight: "50px",
                                                            color: "#a19f9d",
                                                            lineHeight: "25px",
                                                            paddingLeft: "20px",
                                                            paddingRight:
                                                              "20px",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          There are no rewinders{" "}
                                                          <br></br> for this
                                                          machine
                                                        </p>
                                                      </CardShimmerStyle>
                                                    </Select.Option>
                                                  ) : (
                                                    <Select.Option
                                                      value="loading"
                                                      disabled
                                                    >
                                                      <CardShimmerStyle>
                                                        <Skeleton
                                                          active
                                                          paragraph={{
                                                            rows: 1,
                                                          }}
                                                        />
                                                        <Skeleton
                                                          active
                                                          paragraph={{
                                                            rows: 1,
                                                          }}
                                                        />
                                                        <Skeleton
                                                          active
                                                          paragraph={{
                                                            rows: 1,
                                                          }}
                                                        />
                                                      </CardShimmerStyle>
                                                    </Select.Option>
                                                  )}
                                                </Select>
                                                {allRewinders.length ? (
                                                  <div
                                                    style={{
                                                      marginTop: "2px",
                                                      marginLeft: "3px",
                                                      fontSize: "13px",
                                                    }}
                                                  >
                                                    {!(type =="rewinding") && `Deckle : ${rewinderMinWidth}
                                                    ${" - "}
                                                    ${rewinderMaxWidth}${" "}
                                                    ${rewinderUnit?.toUpperCase()}${" "}`}
                                                  </div>
                                                ) : null}
                                              </Row>
                                            </HaberForm>
                                          </DetailFields>
                                        </div>
                                      )}
                                      {((type === "cutting" &&
                                        processType == "singleStage") ||
                                        processType == "multiStage") && (
                                        <div
                                          style={{
                                            marginTop: "4px",
                                            marginBottom: "-44px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginBottom: "3px",
                                              marginLeft: "-168px",
                                              fontSize: "13px",
                                            }}
                                          >
                                            <label>Select Cutter:</label>
                                          </div>
                                          <DetailFields>
                                            <HaberForm>
                                              <Row style={{ width: "100%" }}>
                                                <Select
                                                  listHeight={150}
                                                  getPopupContainer={(
                                                    trigger
                                                  ) =>
                                                    document.getElementById(
                                                      "rewinderDropdown"
                                                    )
                                                  }
                                                  disabled = {isDummyJC}
                                                  style={{ width: "100%" }}
                                                  placeholder="Select Cutter"
                                                  suffixIcon={<DownArrowDraw />}
                                                  onBlur={OnCuttertoggleSelect}
                                                  onFocus={OnCuttertoggleSelect}
                                                  showSearch={
                                                    allCutters &&
                                                    allCutters.length
                                                  }
                                                  optionFilterProp="children"
                                                  filterOption={(
                                                    input,
                                                    option
                                                  ) =>
                                                    option?.key
                                                      ?.toString()
                                                      .toLowerCase()
                                                      .includes(
                                                        input.toLowerCase()
                                                      )
                                                  }
                                                  value={selectedCutter}
                                                  onChange={(e) => {
                                                    onCutterChange(e);
                                                  }}
                                                >
                                                  {allCutters &&
                                                  allCutters.length &&
                                                  processType ==
                                                    "singleStage" ? (
                                                    allCutters?.map(
                                                      (cutter) => (
                                                        <Option
                                                          key={cutter?.name}
                                                        >
                                                          <p
                                                            style={{
                                                              textAlign: "left",
                                                              marginBottom:
                                                                "0px",
                                                            }}
                                                          >
                                                            {cutter?.name}
                                                            {`( ` +
                                                              capitalize(
                                                                cutter?.type
                                                              ) +
                                                              ` ) `}
                                                          </p>
                                                          <br />
                                                          <p
                                                            style={{
                                                              fontSize: "10px",
                                                              textAlign: "left",
                                                              marginTop:
                                                                "-22px",
                                                              marginBottom:
                                                                "0px",
                                                              color:
                                                                "rgba(0, 0, 0, 0.85)",
                                                              lineHeight:
                                                                "22px",
                                                            }}
                                                          >
                                                            {"Deckle: "}
                                                            {+cutter?.minimum_width +
                                                              " - " +
                                                              cutter?.maximum_width +
                                                              " " +
                                                              cutter?.units?.minimum_width?.toUpperCase()}
                                                          </p>
                                                        </Option>
                                                      )
                                                    )
                                                  ) : allCutters &&
                                                    allCutters.length &&
                                                    processType ==
                                                      "multiStage" ? (
                                                    allCutters
                                                      .filter(
                                                        (data) =>
                                                          data.type == "simplex"
                                                      )
                                                      ?.map((cutter) => (
                                                        <Option
                                                          key={cutter?.name}
                                                        >
                                                          <p
                                                            style={{
                                                              textAlign: "left",
                                                              marginBottom:
                                                                "0px",
                                                            }}
                                                          >
                                                            {cutter?.name}
                                                            {`( ` +
                                                              capitalize(
                                                                cutter?.type
                                                              ) +
                                                              ` ) `}
                                                          </p>
                                                          <br />
                                                          <p
                                                            style={{
                                                              fontSize: "10px",
                                                              textAlign: "left",
                                                              marginTop:
                                                                "-22px",
                                                              marginBottom:
                                                                "0px",
                                                              color:
                                                                "rgba(0, 0, 0, 0.85)",
                                                              lineHeight:
                                                                "22px",
                                                            }}
                                                          >
                                                            {"Deckle: "}
                                                            {+cutter?.minimum_width +
                                                              " - " +
                                                              cutter?.maximum_width +
                                                              " " +
                                                              cutter?.units?.minimum_width?.toUpperCase()}
                                                          </p>
                                                        </Option>
                                                      ))
                                                  ) : allCutters ? (
                                                    <Select.Option
                                                      value="loading"
                                                      disabled
                                                    >
                                                      <CardShimmerStyle>
                                                        {/* <Skeleton active paragraph={{ rows: 1 }} />
                                                <Skeleton active paragraph={{ rows: 1 }} />
                                                <Skeleton active paragraph={{ rows: 1 }} /> */}
                                                        <p
                                                          style={{
                                                            paddingTop: "20px",
                                                            minHeight: "50px",
                                                            color: "#a19f9d",
                                                            lineHeight: "25px",
                                                            paddingLeft: "20px",
                                                            paddingRight:
                                                              "20px",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          There are no cutters{" "}
                                                          <br></br> for this
                                                          machine
                                                        </p>
                                                      </CardShimmerStyle>
                                                    </Select.Option>
                                                  ) : (
                                                    <Select.Option
                                                      value="loading"
                                                      disabled
                                                    >
                                                      <CardShimmerStyle>
                                                        <Skeleton
                                                          active
                                                          paragraph={{
                                                            rows: 1,
                                                          }}
                                                        />
                                                        <Skeleton
                                                          active
                                                          paragraph={{
                                                            rows: 1,
                                                          }}
                                                        />
                                                        <Skeleton
                                                          active
                                                          paragraph={{
                                                            rows: 1,
                                                          }}
                                                        />
                                                      </CardShimmerStyle>
                                                    </Select.Option>
                                                  )}
                                                </Select>
                                                {allCutters.length ? (
                                                  <div
                                                    style={{
                                                      marginTop: "2px",
                                                      marginLeft: "3px",
                                                      fontSize: "13px",
                                                    }}
                                                  >
                                                    Deckle : {cutterMinWidth}
                                                    {" - "}
                                                    {cutterMaxWidth}{" "}
                                                    {cutterUnit}{" "}
                                                  </div>
                                                ) : null}
                                              </Row>
                                            </HaberForm>
                                          </DetailFields>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })
                        : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
                            return <PaperMachineCardShimmer details={item} />;
                          })}
                    </SimpleBar>
                  </PaperMachineScroll>
                </div>
              </PaperMachineRecordsData>
            </Col>
            <Col span={16}>
              {/* {!paperMachineCheckedBoxId &&( 
                <PaperMachineRecordsData>
                  <div className="paperCoverBg">
                    <img src={paperCover} alt="Paper Machine" />
                    <p>
                      Select a paper machine and a converting machine to proceed<br />
                      to the next step
                    </p>
                  </div>
                </PaperMachineRecordsData>
              )} */}
              {
              (processType == "singleStage"
                ? type === "rewinding"
                  ? !selectedRewinder
                  : !selectedCutter
                : !selectedCutter || !selectedRewinder) 
                 ? (
                <PaperMachineRecordsData>
                  <div className="paperCoverBg">
                    <img src={paperCover} alt="Paper Machine" />
                    <p>
                      {/* You need to select a paper machine and Rewinder/Cutter<br />
                    before proceeding to next step */}
                      Select the conversion process and machines for which you
                      <br />
                      want to create a plan to proceed to the next step. <br />
                      <br />
                      You can choose <b>Single Stage Converting Process</b> for
                      only <br />
                      rewinding or cutting from jumbo rolls. You can choose{" "}
                      <b>Multi Stage</b> <br />
                      <b>Converting Process</b> where first rewinding has to be
                      done and later <br />
                      cutting has to be done from rewinder reels.
                    </p>
                  </div>
                </PaperMachineRecordsData>
              ):''}
              {getPaperMachineList &&
                paperMachineCheckedBoxId &&
                (processType == "singleStage"
                  ? type === "rewinding"
                    ? selectedRewinder
                    : selectedCutter
                  : selectedCutter && selectedRewinder) && (
                  <DetailFields>
                    <HaberForm>
                      <div className="groupDetailWrap">
                        <Form
                          name="basic"
                          autoComplete="off"
                          form={form}
                          onFinish={onFinishPaperMachine}
                          onValuesChange={onValuesChange}
                        >
                          {/* <Row gutter={[24]} className="groupForm">
                          <Col span={24}>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>GSM Range</label>
                                  <p>
                                    {getPaperMachineList.minimum_gsm} -{" "}
                                    {getPaperMachineList.maximum_gsm} GSM
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Deckle Width Range</label>
                                  <p>
                                    {getPaperMachineList.minimum_width} -{" "}
                                    {getPaperMachineList.maximum_width} CM
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Row className="centerAlign">
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Order Type</label>
                                  <p>
                                    {getPaperMachineList.order_type === "both"
                                      ? "Reels, Sheets"
                                      : capitalize(
                                          getPaperMachineList.order_type
                                        )}
                                  </p>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="boxFieldTitle">
                                  <label>Production Capacity</label>
                                  <p>
                                    {getPaperMachineList.production_capacity} MT
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row> */}
                          <Row className="centerAlign">
                            <Col span={12} style={{ paddingRight: "20px" }}>
                              <div className="boxFieldTitle">
                                <label>Deckle Planning Criteria</label>
                                <p>
                                  Deckle planning can be done on the basis of
                                  specific purchase order numbers or product
                                  qualities
                                </p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div
                                className="boxFormType switchRadio"
                                style={{
                                  justifyContent: "flex-end",
                                  display: "flex",
                                }}
                              >
                                <Form.Item
                                  name="planning_type"
                                  initialValue={planningType}
                                  style={{
                                    width: "300%",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  <PlanningStyle
                                    style={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <Radio.Group
                                      options={planningCriteria}
                                      onChange={handlePlanningTypeChange}
                                      value={planningType}
                                      optionType="button"
                                      buttonStyle="solid"
                                      disabled = {isDummyJC}
                                    />
                                  </PlanningStyle>
                                </Form.Item>
                              </div>
                            </Col>
                          </Row>
                          <Row gutter={[24]} className="groupForm">
                            <Col span={24} className="blockBreak">
                              {planningType === "quality" && (
                                <Row
                                  className="centerAlign"
                                  style={{
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  <Col
                                    span={12}
                                    style={{ paddingRight: "20px" }}
                                  >
                                    <div className="boxFieldTitle">
                                      <label>Select Grades and Qualities</label>
                                      <p>
                                        Select grades and qualities to plan
                                        deckle
                                      </p>
                                    </div>
                                  </Col>
                                  <Col span={12} className="d-flex1">
                                    <div className="boxFormType unitSelect">
                                      <PaperMachineGradeSelect>
                                        <Form.Item
                                          name="grade"
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "This is a required field",
                                            },
                                          ]}
                                          className=""
                                          initialValue={
                                            formValues ? selectedGrade : null
                                          }
                                        >
                                          <Select
                                            placeholder="Select Grade"
                                            suffixIcon={
                                              isGradeDropdownOpen ? (
                                                <DropDownSearchDraw />
                                              ) : (
                                                <DownArrowDraw />
                                              )
                                            }
                                            onBlur={OnGradetoggleSelect}
                                            onFocus={OnGradetoggleSelect}
                                            showSearch
                                            optionFilterProp="children"
                                            disabled={
                                              type === "rewinding"
                                                ? !selectedRewinder
                                                : !selectedCutter
                                            }
                                            filterOption={(input, option) =>
                                              option.children
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                            onChange={(e) => {
                                              // console.log("selected", e);
                                              setSelectedGrade(e);
                                              setSelected([]);
                                              setShowError({
                                                error: false,
                                                message: "",
                                              });
                                              // setSelectedGQ([]);
                                              getProductParameters(e);
                                              // onChangeMachineGradeSelect(e);
                                            }}
                                          >
                                            {grades?.map((machineGrade) => (
                                              <Option key={machineGrade.name}>
                                                {machineGrade.name}
                                              </Option>
                                            ))}
                                          </Select>
                                        </Form.Item>
                                      </PaperMachineGradeSelect>
                                    </div>
                                    {/* {console.log("qua", selectedGrade, qualities)} */}
                                    <div
                                      className="boxFormType unitSelect"
                                      style={{ marginBottom: "0" }}
                                    >
                                      <PaperMachineQualitySelect>
                                        {/* <Form.Item
                                    name="Quality"
                                    rules={[{ required: true }]}
                                    className=""
                                  > */}
                                        <MultiSelect
                                          className="multiQuality"
                                          options={qualities}
                                          name="quality"
                                          value={selected}
                                          onChange={
                                            onChangeMachineQualitySelect
                                          }
                                          labelledBy="Quality"
                                          valueRenderer={(selected) => {
                                            if (!selected.length)
                                              return "Select Quality";
                                          }}
                                        />
                                        {/* {selected.map((machinequality) => (
                                        <Option key={machinequality}>
                                          {machinequality}
                                        </Option>
                                      ))} */}
                                        {/* </MultiSelect> */}
                                        {/* </Form.Item> */}
                                        {/* <span
                                      className={
                                        selected
                                          ? "MachineGradeSelect-active"
                                          : "MachineGradeSelect"
                                      }
                                    >
                                      {selected.map((item) => item.value)}
                                    </span> */}
                                      </PaperMachineQualitySelect>
                                    </div>
                                  </Col>
                                  <Col span={12}>
                                    <PaperMachineGradeSelect>
                                      <div className="mainMachineGrade">
                                        {selectedGQ &&
                                          selectedGQ.map((item) => {
                                            return (
                                              <span
                                                className={
                                                  selectedGrade
                                                    ? "MachineGradeSelect-active"
                                                    : "MachineGradeSelect"
                                                }
                                              >
                                                {item.grade}
                                                {item.quality
                                                  ? ` - ${item.quality}`
                                                  : ""}
                                                <Button
                                                  className="textTypeBtn textBtnIcon paperButtonBg"
                                                  onClick={() => {
                                                    removeGQ(item);
                                                  }}
                                                >
                                                  <Iconmoon
                                                    icon="wrong"
                                                    size={14}
                                                    color="#EA655B"
                                                  />
                                                </Button>
                                              </span>
                                            );
                                          })}
                                      </div>
                                    </PaperMachineGradeSelect>
                                  </Col>
                                </Row>
                              )}
                              <PaperBlockList>
                                {planningType === "quality" && (
                                  <Row className="centerAlign">
                                    <Col
                                      span={12}
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className="boxFieldTitle removeStar">
                                        <label>GSM Range</label>
                                        <p>Specify GSM range to plan deckle</p>
                                      </div>
                                    </Col>

                                    <Col span={12} className="d-flex">
                                      <Row className="centerAlign">
                                        <Col
                                          span={24}
                                          className="d-flex twoFields"
                                        >
                                          <div
                                            className="boxFormType"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <Form.Item
                                              name="min_gsm"
                                              label="Minimum GSM"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                                {
                                                  pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                                  message:
                                                    "Only numeric characters are allowed upto 3 decimal points",
                                                },
                                                {
                                                  validator(_, value) {
                                                    if (value === 0) {
                                                      return Promise.reject(
                                                        "Min. GSM cannot be zero"
                                                      );
                                                    } else if (
                                                      value <
                                                        getPaperMachineList?.minimum_gsm ||
                                                      value >
                                                        getPaperMachineList?.maximum_gsm
                                                    ) {
                                                      return Promise.reject(
                                                        "Invalid input"
                                                      );
                                                    } else {
                                                      return Promise.resolve();
                                                    }
                                                  },
                                                },
                                              ]}
                                              initialValue={
                                                formValues
                                                  ? formValues.minimum_gsm
                                                  : ""
                                              }
                                              className="dBlock"
                                            >
                                              <Input
                                                placeholder="Enter min GSM"
                                                disabled={
                                                  type === "rewinding"
                                                    ? !selectedRewinder
                                                    : !selectedCutter
                                                }
                                                onChange={onGSMValidation}
                                              />
                                            </Form.Item>
                                          </div>
                                          <div
                                            className="boxFormType"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <Form.Item
                                              name="max_gsm"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                                {
                                                  pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                                  message:
                                                    "Only numeric characters are allowed upto 3 decimal points",
                                                },
                                                {
                                                  validator(_, value) {
                                                    if (value === 0) {
                                                      return Promise.reject(
                                                        "Min. GSM cannot be zero"
                                                      );
                                                    } else if (
                                                      value <
                                                        getPaperMachineList?.minimum_gsm ||
                                                      value >
                                                        getPaperMachineList?.maximum_gsm
                                                    ) {
                                                      return Promise.reject(
                                                        "Invalid input"
                                                      );
                                                    } else {
                                                      return Promise.resolve();
                                                    }
                                                  },
                                                },
                                              ]}
                                              label="Maximum GSM"
                                              className="dBlock"
                                              initialValue={
                                                formValues
                                                  ? formValues.maximum_gsm
                                                  : ""
                                              }
                                            >
                                              <Input
                                                placeholder="Enter max GSM"
                                                disabled={
                                                  type === "rewinding"
                                                    ? !selectedRewinder
                                                    : !selectedCutter
                                                }
                                                onChange={onGSMValidation}
                                              />
                                            </Form.Item>
                                          </div>
                                        </Col>
                                        {isGSMError ? (
                                          <span
                                            className="errorText"
                                            style={{ color: "#ea4e2c" }}
                                          >
                                            Max GSM cannot be less than Min GSM
                                          </span>
                                        ) : null}
                                      </Row>
                                    </Col>
                                  </Row>
                                )}

                                {showBFRange && planningType === "quality" && (
                                  <Row className="centerAlign">
                                    <Col
                                      span={12}
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className="boxFieldTitle removeStar">
                                        <label>
                                          BF Range <span>(Optional)</span>
                                        </label>
                                        <p>Specify BF range to plan deckle</p>
                                      </div>
                                    </Col>

                                    <Col span={12} className="d-flex">
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          name="min_bf"
                                          label="Minimum BF"
                                          rules={[
                                            {
                                              pattern: new RegExp(
                                                /^\d+(\.\d{0,2})?$/
                                              ),
                                              message:
                                                "Only Numeric value is possible",
                                            },
                                          ]}
                                          initialValue={
                                            formValues &&
                                            formValues.burst_factor_range
                                              ? formValues.burst_factor_range
                                                  .minimum
                                              : ""
                                          }
                                          className="dBlock"
                                        >
                                          <Input
                                            placeholder="Enter min BF"
                                            disabled={
                                              type === "rewinding"
                                                ? !selectedRewinder
                                                : !selectedCutter
                                            }
                                          />
                                        </Form.Item>
                                      </div>
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          name="max_bf"
                                          rules={[
                                            {
                                              pattern: new RegExp(
                                                /^\d+(\.\d{0,2})?$/
                                              ),
                                              message:
                                                "Only Numeric value is possible",
                                            },
                                          ]}
                                          label="Maximum BF"
                                          className="dBlock"
                                          initialValue={
                                            formValues &&
                                            formValues.burst_factor_range
                                              ? formValues.burst_factor_range
                                                  .maximum
                                              : ""
                                          }
                                        >
                                          <Input placeholder="Enter max BF" />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  </Row>
                                )}

                                {showMoisture && planningType === "quality" && (
                                  <Row className="centerAlign">
                                    <Col
                                      span={12}
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className="boxFieldTitle removeStar">
                                        <label>
                                          Moisture <span>(Optional)</span>
                                        </label>
                                        <p>
                                          Specify moisture range to plan deckle
                                        </p>
                                      </div>
                                    </Col>

                                    <Col span={12} className="d-flex">
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          name="min_moisture"
                                          label="Minimum Moisture"
                                          rules={[
                                            {
                                              pattern: new RegExp(
                                                /^\d+(\.\d{0,2})?$/
                                              ),
                                              message:
                                                "Only Numeric value is possible",
                                            },
                                          ]}
                                          initialValue={
                                            formValues &&
                                            formValues.moisture_range
                                              ? formValues.moisture_range
                                                  .minimum
                                              : ""
                                          }
                                          className="dBlock"
                                        >
                                          <Input placeholder="Enter min Moisture" />
                                        </Form.Item>
                                      </div>
                                      <div
                                        className="boxFormType"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <Form.Item
                                          name="max_moisture"
                                          rules={[
                                            {
                                              pattern: new RegExp(
                                                /^\d+(\.\d{0,2})?$/
                                              ),
                                              message:
                                                "Only Numeric value is possible",
                                            },
                                          ]}
                                          label="Maximum Moisture"
                                          className="dBlock"
                                          initialValue={
                                            formValues &&
                                            formValues.moisture_range
                                              ? formValues.moisture_range
                                                  .maximum
                                              : ""
                                          }
                                        >
                                          <Input placeholder="Enter max Moisture" />
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  </Row>
                                )}

                                {planningType === "quality" && (
                                  <Row
                                    className="centerAlign"
                                    style={{
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <Col
                                      span={12}
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className="boxFieldTitle removeStar">
                                        <label>
                                          Customer <span>(Optional)</span>
                                        </label>
                                        <p>
                                          Select customers for which orders
                                          should be considered in deckle plan
                                        </p>
                                      </div>
                                    </Col>

                                    <Col span={12}>
                                      <div
                                        className="boxFormType unitSelect"
                                        style={{ marginBottom: "0" }}
                                      >
                                        <PaperMachineQualitySelect>
                                          <MultiSelect
                                            className="multiQuality"
                                            hasSelectAll={false}
                                            options={customersList}
                                            name="customer"
                                            value={selectedCustomer}
                                            onChange={onChangeCustomer}
                                            labelledBy="Customer"
                                            valueRenderer={(selected) => {
                                              if (!selected.length)
                                                return "Select Customer";
                                            }}
                                          />
                                        </PaperMachineQualitySelect>
                                      </div>
                                    </Col>

                                    <Col span={12}>
                                      <PaperMachineGradeSelect>
                                        <div className="mainMachineGrade">
                                          {selectedCustomerList &&
                                            selectedCustomerList.map((item) => {
                                              return (
                                                <span
                                                  className={
                                                    selectedCustomer
                                                      ? "MachineGradeSelect-active"
                                                      : "MachineGradeSelect"
                                                  }
                                                >
                                                  {item.label}
                                                  <Button
                                                    className="textTypeBtn textBtnIcon paperButtonBg"
                                                    onClick={() => {
                                                      removeCustomer(
                                                        item.value
                                                      );
                                                    }}
                                                  >
                                                    <Iconmoon
                                                      icon="wrong"
                                                      size={14}
                                                      color="#EA655B"
                                                    />
                                                  </Button>
                                                </span>
                                              );
                                            })}
                                        </div>
                                      </PaperMachineGradeSelect>
                                    </Col>
                                  </Row>
                                )}

                                {planningType === "quality" && (
                                  <Row className="centerAlign">
                                    <Col
                                      span={12}
                                      style={{ paddingRight: "20px" }}
                                    >
                                      <div className="boxFieldTitle">
                                        <label>Order Type</label>
                                        <p>
                                          Select the type of orders to consider
                                          in deckle planning
                                        </p>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        className="boxFormType switchRadio threeSwitch"
                                        style={{
                                          justifyContent: "flex-end",
                                          display: "flex",
                                        }}
                                      >
                                        <Form.Item
                                          name="order_type"
                                          initialValue={
                                            formValues & formValues?.order_type
                                              ? formValues?.order_type
                                              : inititalOrderType
                                            // formValues ? formValues.order_type : updatedOrderTypeOptions.filter(type => type.disabled !== true).length > 2 ?
                                            // updatedOrderTypeOptions[2].value : updatedOrderTypeOptions.filter(type => type.disabled !== true)[0].value
                                          }
                                          style={{
                                            width: "200%",
                                            justifyContent: "flex-start",
                                            display: "flex",
                                          }}
                                        >
                                          <div
                                            style={{
                                              justifyContent: "start-end",
                                              display: "flex",
                                            }}
                                          >
                                            <Radio.Group
                                              options={updatedOrderTypeOptions}
                                              onChange={handleOrderTypeChange}
                                              value={orderType}
                                              optionType="button"
                                              buttonStyle="solid"
                                              // disabled={inititalOrderType !== "both"}
                                              disabled={isEnabled}
                                            />
                                          </div>
                                        </Form.Item>
                                      </div>
                                    </Col>
                                  </Row>
                                )}
                                {planningType === "quality" && (
                                <Row className="centerAlign">
                                      <Col span={12} 
                                      style={{ paddingRight: "20px" }}
                                      >
                                        <div className="boxFieldTitle">
                                          <label>Order Window</label>
                                          <p>
                                            Specify the number of days of
                                            delivery window to select orders
                                          </p>
                                        </div>
                                      </Col>
                                      <Col span={12} className="d-flex twoFields">
                                        <div className="boxFormType">
                                              <Form.Item
                                                name="order_window_type"
                                                rules={[
                                                  {
                                                    required: true,
                                                    message:
                                                      "This is a required field",
                                                  },
                                                ]}
                                                initialValue={
                                                  formValues
                                                    ? formValues.order_window_type
                                                    : globalSettings?.order_window_type ===
                                                      "fixed"
                                                    ? "Fixed Period"
                                                    : "Flexible"
                                                }
                                                className=""
                                              >
                                                <Select
                                                  placeholder="Select Product"
                                                  suffixIcon={
                                                    isProductDropdownOpen ? (
                                                      <DropDownSearchDraw />
                                                    ) : (
                                                      <DownArrowDraw />
                                                    )
                                                  }
                                                  onBlur={OnProductToggleSelect}
                                                  onFocus={
                                                    OnProductToggleSelect
                                                  }
                                                  optionFilterProp="children"
                                                  onChange={
                                                    handleOrderWindowTypeChange
                                                  }
                                                >
                                                  {orderWindowTypeOptions.map(
                                                    (product) => (
                                                      <Option
                                                        key={product.value}
                                                      >
                                                        {product.label}
                                                      </Option>
                                                    )
                                                  )}
                                                </Select>
                                              </Form.Item>
                                            </div>

                                            {orderWindowType === "fixed" && (
                                              <div className="boxFormType">
                                                <Form.Item
                                                  name="order_window"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This is a required field",
                                                    },
                                                    // {
                                                    //   pattern: new RegExp(
                                                    //     /^\d+(\.\d+)?$/
                                                    //   ),
                                                    //   message:
                                                    //     "Only numerical values are allowed",
                                                    // },                                                    
                                                    {
                                                      pattern: /^[0-9]*$/,
                                                      message: "Only numerical values are allowed",
                                                    },
                                                    {
                                                      validator(_, value) {
                                                        if (value &&
                                                          value == 0 &&
                                                          orderWindowType ===
                                                            "fixed"
                                                        )
                                                          return Promise.reject(
                                                            "Order window should be more than 0"
                                                          );
                                                        else
                                                          return Promise.resolve();
                                                      },
                                                    },
                                                  ]}
                                                  initialValue={
                                                    formValues
                                                      ? formValues.order_window
                                                      : globalSettings.order_window
                                                  }
                                                  className=""
                                                >
                                                  <Input
                                                    placeholder="Enter the number of days"
                                                    disabled={
                                                      type === "rewinding"
                                                        ? !selectedRewinder
                                                        : !selectedCutter
                                                    }
                                                  />
                                                </Form.Item>
                                              </div>
                                            )}
                                      </Col>
                                    </Row>
                                )}
                                {(allCutters?.find(
                                  (cutter) => cutter?.code === code
                                )?.type == "duplex" ||
                                  allCutters?.find(
                                    (cutter) => cutter?.code === code
                                  )?.type == "simplex") &&
                                  processType == "singleStage" && (
                                    <Row className="centerAlign">
                                      <Col
                                        span={12}
                                        style={{ paddingRight: "20px" }}
                                      >
                                        <div className="boxFieldTitle">
                                          <label>
                                            Minimum weight in combination{" "}
                                          </label>
                                          <p>
                                            The minimum weight that a
                                            combination should have to qualify
                                            as a part of solution
                                          </p>
                                        </div>
                                      </Col>
                                      <Col span={12} className="d-flex">
                                        <div className="boxFormType">
                                          <Form.Item
                                            name="min_weight_per_partition"
                                            rules={[
                                              {
                                                pattern: new RegExp(
                                                  /^\d+(\.\d{0,3})?$/
                                                ),
                                                message:
                                                  "Upto 3 decimal point values is accepted",
                                              },
                                            ]}
                                            className=""
                                            initialValue={
                                              formValues?.partitionWeightUnit &&
                                              location?.state?.minWeight
                                                ? (
                                                    location.state.minWeight *
                                                    conversionFactorUnitsToTonne[
                                                      formValues
                                                        .partitionWeightUnit
                                                    ] *
                                                    conversionFactorTonneToUnits[
                                                      formValues
                                                        .partitionWeightUnit
                                                    ]
                                                  ).toFixed(3)
                                                : (
                                                    0.5 *
                                                    conversionFactorTonneToUnits[
                                                      unitData?.units_management
                                                        .weight.default
                                                    ]
                                                  ).toFixed(3)
                                            }
                                          >
                                            <Input />
                                          </Form.Item>
                                        </div>
                                        {unitData.units_management?.weight ? (
                                          <div
                                            className="boxFormType unitSelect"
                                            style={{ marginBottom: "0" }}
                                          >
                                            <Form.Item
                                              name="partitionWeightUnit"
                                              rules={[
                                                {
                                                  required: true,
                                                  message:
                                                    "This is a required field",
                                                },
                                              ]}
                                              initialValue={
                                                formValues
                                                  ? formValues.partitionWeightUnit
                                                  : unitData?.units_management
                                                      ?.weight?.default
                                              }
                                              className="dBlock"
                                            >
                                              <Select
                                                placeholder="Unit"
                                                suffixIcon={<DownArrowDraw />}
                                                onChange={() => {
                                                  changeDeckleLength();
                                                }}
                                              >
                                                {unitData?.units_management?.weight.data.map(
                                                  (weight) => (
                                                    <Option key={weight}>
                                                      {
                                                        weightUnit[weight]
                                                          .displayName
                                                      }
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                            </Form.Item>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                  )}

                                {processType == "singleStage" && (
                                  <Row
                                    className="centerAlign"
                                    style={{ width: "100%" }}
                                  >
                                    {" "}
                                    <CollapseStyle style={{ width: "100%" }}>
                                      <Collapse
                                        // onChange={onChangeCollpase}
                                        expandIconPosition="right"
                                        bordered={false}
                                        style={{
                                          backgroundColor: "white",
                                          width: "100%",
                                        }}
                                      >
                                        {console.log(formValues)}
                                        <Panel
                                          forceRender={true}
                                          header={
                                            type == "rewinding"
                                              ? "Rewinder Specification: " +
                                                selectedRewinder
                                              : "Cutter Specification: " +
                                                selectedCutter +
                                                " ( " +
                                                capitalize(
                                                  allCutters?.find(
                                                    (cutter) =>
                                                      cutter?.code === code
                                                  )?.type
                                                ) +
                                                " )"
                                          }
                                          // key="1"
                                        >
                                          {type == "rewinding"?<Form.List
                                            name="gsmWiseWidths"
                                            initialValue={
                                                formValues
                                                  ? formValues?.processType == "singleStage" 
                                                      ? formValues?.gsm_wise_configs[formValues?.machine_code]
                                                      : formValues?.machine_data[0]?.gsm_wise_configs[formValues?.machine_code]
                                                  : []
                                              }
                                          >
                                            {(fields)=>(
                                              <>
                                                <Collapse
                                                  activeKey={activeKey}
                                                  onChange={(e)=>{setActiveKey(e)}}
                                                  expandIconPosition={"right"}
                                                  bordered={false}
                                                  style={{marginLeft:"24px"}}
                                                >
                                                  {fields.map((field,index)=>(
                                                    <Panel
                                                      key={field.key}
                                                      style={{
                                                        backgroundColor:"rgba(250, 249, 248, 1)",
                                                        border:"1px solid rgba(225, 223, 221, 1)",
                                                        borderRadius:"6px", marginBlock:"10px",
                                                        overflow:"hidden",
                                                      }}
                                                      header={<Label ind={index} isActive={!activeKey.includes(field.key.toString())} form={form}/>}
                                                    >
                                                      <GSMWiseCards form={form} field={field}/>
                                                    </Panel>
                                                  )
                                                  )}
                                                </Collapse>
                                              </>
                                            )
                                            }
                                          </Form.List>:<>
                                          <Row className="centerAlign">
                                            <Col
                                              span={12}
                                              style={{ paddingRight: "20px" }}
                                            >
                                              <div className="boxFieldTitle removeStar">
                                                <label>Edge Trim</label>
                                                <p>
                                                  Specify the left and right
                                                  edge trim for the machine
                                                </p>
                                              </div>
                                            </Col>
                                            <Col
                                              span={12}
                                              className="d-flex threeFields"
                                            >
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  name="min_width"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This is a required field",
                                                    },
                                                    {
                                                      pattern: new RegExp(
                                                        /^\d+(\.\d{0,3})?$/
                                                      ),
                                                      message: "Invalid input",
                                                    },
                                                    // {
                                                    //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                                                    //   message:
                                                    //     "Only numerical values are allowed",
                                                    // },
                                                  ]}
                                                  initialValue={
                                                    leftEdgeTrim == 0 ||
                                                    leftEdgeTrim == "0" ||
                                                    leftEdgeTrim == null
                                                      ? 0
                                                      : leftEdgeTrim
                                                      ? leftEdgeTrim
                                                      : ""
                                                  }
                                                  label="Left Trim"
                                                  className="dBlock"
                                                >
                                                  <Input
                                                    placeholder="Left trim"
                                                    onChange={() => {
                                                      // setLeftTrim(e.target.value);
                                                      changeDeckleLength();
                                                    }}
                                                  />
                                                </Form.Item>
                                              </div>
                                              <div
                                                className="boxFormType"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  name="max_width"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This is a required field",
                                                    },
                                                    {
                                                      pattern: new RegExp(
                                                        /^\d+(\.\d{0,3})?$/
                                                      ),
                                                      message: "Invalid input",
                                                    },
                                                  ]}
                                                  initialValue={
                                                    rightEdgeTrim == 0 ||
                                                    rightEdgeTrim == "0" ||
                                                    rightEdgeTrim == null
                                                      ? 0
                                                      : rightEdgeTrim
                                                      ? rightEdgeTrim
                                                      : ""
                                                  }
                                                  label="Right Trim"
                                                  className="dBlock"
                                                >
                                                  <Input
                                                    placeholder="Right trim"
                                                    onChange={() => {
                                                      // setRightTrim(e.target.value);
                                                      changeDeckleLength();
                                                    }}
                                                  />
                                                </Form.Item>
                                              </div>
                                              <div
                                                className="boxFormType unitSelect"
                                                style={{ marginBottom: "0" }}
                                              >
                                                <Form.Item
                                                  name="Unit"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This is a required field",
                                                    },
                                                  ]}
                                                  initialValue={
                                                    formValues
                                                      ? formValues?.units?.left_edge_trim
                                                      : cutterUnits?.left_edge_trim
                                                  }
                                                  label="Unit"
                                                  className="dBlock"
                                                >
                                                  <Select
                                                    placeholder="Unit"
                                                    suffixIcon={
                                                      <DownArrowDraw />
                                                    }
                                                    onChange={() => {
                                                      changeDeckleLength();
                                                    }}
                                                  >
                                                    {unitData?.units_management?.length?.data?.map(
                                                      (deckleWidth) => (
                                                        <Option
                                                          key={deckleWidth}
                                                        >
                                                          {
                                                            lengthUnit[
                                                              deckleWidth
                                                            ].displayName
                                                          }
                                                        </Option>
                                                      )
                                                    )}
                                                  </Select>
                                                </Form.Item>
                                              </div>
                                            </Col>
                                          </Row>

                                          <PaperBlockList> 
                                            {/* <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Effective Deckle Length</label>
                                <p>Available deckle length to match deckle after adjusting for edge trim</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="effective_deckle_length"
                                                                
                                  className=""
                                  shouldUpdate
                                >
                                
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row> */}
                                            <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle">
                                                  <label>
                                                    Effective Deckle Length
                                                  </label>
                                                  <p>
                                                    Available deckle length to
                                                    match deckle after adjusting
                                                    for edge trim
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col span={12}>
                                                <div className="boxFormType">
                                                  <Form.Item
                                                    name="effective_deckle_length"
                                                    className=""
                                                    initialValue={
                                                      formValues?.effective_deckle_length
                                                        ? formValues.effective_deckle_length
                                                        : location.state?.body
                                                            ?.effective_deckle_length
                                                        ? location.state?.body
                                                            ?.effective_deckle_length
                                                        : ""
                                                    }
                                                    shouldUpdate
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                    ]}
                                                  >
                                                    <Input
                                                      disabled
                                                      // value={effectiveDeckle.toString()}
                                                      placeholder="Enter Deckle Length"
                                                      suffix={
                                                        <label className="floating-label">
                                                          {form.getFieldValue(
                                                            "Unit"
                                                          )}
                                                        </label>
                                                      }
                                                    />
                                                  </Form.Item>
                                                </div>
                                              </Col>
                                            </Row>
                                          </PaperBlockList></>}
                                          {/* <Row className="centerAlign">
                                            <Col
                                              span={12}
                                              style={{ paddingRight: "20px" }}
                                            >
                                              <div className="boxFieldTitle">
                                                <label>
                                                  Maximum Number of cutters
                                                </label>
                                                <p>
                                                  Specify maximum number of
                                                  cutters including edge cutters
                                                  which can be placed on deckle
                                                </p>
                                              </div>
                                            </Col>
                                            <Col span={12}>
                                              <div className="boxFormType">
                                                <Form.Item
                                                  name="cutters"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This is a required field",
                                                    },
                                                    {
                                                      pattern: new RegExp(
                                                        /^\d+(\.\d+)?$/
                                                      ),
                                                      message:
                                                        "Only numerical values are allowed",
                                                    },
                                                    {
                                                      validator(_, value) {
                                                        if (value == 0)
                                                          return Promise.reject(
                                                            "Cutters should be more than 0"
                                                          );
                                                        else
                                                          return Promise.resolve();
                                                      },
                                                    },
                                                  ]}
                                                  initialValue={
                                                    maxNoOfCutters
                                                      ? maxNoOfCutters
                                                      : ""
                                                  }
                                                  className=""
                                                >
                                                  <Input placeholder="Maximum Number of cutters" />
                                                </Form.Item>
                                              </div>
                                            </Col>
                                          </Row> */}
                                          <Row className="centerAlign">
                                            <Col
                                              span={12}
                                              style={{ paddingRight: "20px" }}
                                            >
                                              <div className="boxFieldTitle">
                                                <label>
                                                  Maximum Number of cutters
                                                </label>
                                                <p>
                                                  Specify maximum number of
                                                  cutters including edge cutters
                                                  which can be placed on deckle
                                                </p>
                                              </div>
                                            </Col>
                                            <Col span={12}>
                                              <div className="boxFormType">
                                                <Form.Item
                                                  name="cutters"
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "This is a required field",
                                                    },
                                                    {
                                                      pattern: new RegExp(
                                                        /^\d+(\.\d+)?$/
                                                      ),
                                                      message:
                                                        "Only numerical values are allowed",
                                                    },
                                                    {
                                                      validator(_, value) {
                                                        if (value == 0)
                                                          return Promise.reject(
                                                            "Cutters should be more than 0"
                                                          );
                                                        else
                                                          return Promise.resolve();
                                                      },
                                                    },
                                                  ]}
                                                  initialValue={
                                                    maxNoOfCutters
                                                      ? maxNoOfCutters
                                                      : ""
                                                  }
                                                  className=""
                                                >
                                                  <Input placeholder="Maximum Number of cutters" />
                                                </Form.Item>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Panel>
                                      </Collapse>
                                    </CollapseStyle>
                                  </Row>
                                )}

                                {processType == "multiStage" && (
                                  <>
                                    <Row
                                      className="centerAlign"
                                      style={{ width: "100%" }}
                                    >
                                      {" "}
                                      <CollapseStyle style={{ width: "100%" }}>
                                        <Collapse
                                          // onChange={onChangeCollpase}
                                          expandIconPosition="right"
                                          bordered={false}
                                          style={{
                                            backgroundColor: "white",
                                            width: "100%",
                                          }}
                                        >
                                          <Panel
                                            forceRender={true}
                                            header={
                                              "Rewinder Specification: " +
                                              selectedRewinder
                                            }
                                            // key="1"
                                          >
                                          <Form.List
                                            name="gsmWiseWidths"
                                            initialValue={
                                                formValues
                                                  ? formValues?.processType == "singleStage" 
                                                      ? formValues?.gsm_wise_configs[formValues?.machine_code]
                                                      : formValues?.machine_data[0]?.gsm_wise_configs[formValues?.machine_code]
                                                  : []
                                              }
                                          >
                                            {(fields)=>(
                                              <>
                                                <Collapse
                                                  activeKey={activeKey}
                                                  onChange={(e)=>{setActiveKey(e)}}
                                                  expandIconPosition={"right"}
                                                  bordered={false}
                                                  style={{marginLeft:"24px"}}
                                                >
                                                  {fields.map((field,index)=>(
                                                    <Panel
                                                      key={field.key}
                                                      style={{
                                                        backgroundColor:"rgba(250, 249, 248, 1)",
                                                        border:"1px solid rgba(225, 223, 221, 1)",
                                                        borderRadius:"6px", marginBlock:"10px",
                                                        overflow:"hidden",
                                                      }}
                                                      header={<Label ind={index} isActive={!activeKey.includes(field.key.toString())} form={form}/>}
                                                    >
                                                      <GSMWiseCards form={form} field={field}/>
                                                    </Panel>
                                                  )
                                                  )}
                                                </Collapse>
                                              </>
                                            )
                                            }
                                          </Form.List>
                                            {/* <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle removeStar">
                                                  <label>Edge Trim</label>
                                                  <p>
                                                    Specify the left and right
                                                    edge trim for the machine
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col
                                                span={12}
                                                className="d-flex threeFields"
                                              >
                                                <div
                                                  className="boxFormType"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="min_width"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d{0,3})?$/
                                                        ),
                                                        message:
                                                          "Invalid input",
                                                      },
                                                      // {
                                                      //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                                                      //   message:
                                                      //     "Only numerical values are allowed",
                                                      // },
                                                    ]}
                                                    initialValue={
                                                      leftEdgeTrim == 0 ||
                                                      leftEdgeTrim == "0" ||
                                                      leftEdgeTrim == null
                                                        ? 0
                                                        : leftEdgeTrim
                                                        ? leftEdgeTrim
                                                        : ""
                                                    }
                                                    label="Left Trim"
                                                    className="dBlock"
                                                  >
                                                    <Input
                                                      placeholder="Left trim"
                                                      onChange={() => {
                                                        // setLeftTrim(e.target.value);
                                                        changeDeckleLength();
                                                      }}
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div
                                                  className="boxFormType"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="max_width"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d{0,3})?$/
                                                        ),
                                                        message:
                                                          "Invalid input",
                                                      },
                                                    ]}
                                                    initialValue={
                                                      rightEdgeTrim == 0 ||
                                                      rightEdgeTrim == "0" ||
                                                      rightEdgeTrim == null
                                                        ? 0
                                                        : rightEdgeTrim
                                                        ? rightEdgeTrim
                                                        : ""
                                                    }
                                                    label="Right Trim"
                                                    className="dBlock"
                                                  >
                                                    <Input
                                                      placeholder="Right trim"
                                                      onChange={() => {
                                                        // setRightTrim(e.target.value);
                                                        changeDeckleLength();
                                                      }}
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div
                                                  className="boxFormType unitSelect"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="Unit"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                    ]}
                                                    initialValue={
                                                      formValues
                                                        ? formValues.Unit
                                                        : unitData
                                                            ?.units_management
                                                            ?.length.default
                                                    }
                                                    label="Unit"
                                                    className="dBlock"
                                                  >
                                                    <Select
                                                      placeholder="Unit"
                                                      suffixIcon={
                                                        <DownArrowDraw />
                                                      }
                                                      onChange={() => {
                                                        changeDeckleLength();
                                                      }}
                                                    >
                                                      {unitData?.units_management?.length?.data?.map(
                                                        (deckleWidth) => (
                                                          <Option
                                                            key={deckleWidth}
                                                          >
                                                            {
                                                              lengthUnit[
                                                                deckleWidth
                                                              ].displayName
                                                            }
                                                          </Option>
                                                        )
                                                      )}
                                                    </Select>
                                                  </Form.Item>
                                                </div>
                                              </Col>
                                            </Row> */}
                                          {/* <PaperBlockList> */}
                                              {/* <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Effective Deckle Length</label>
                                <p>Available deckle length to match deckle after adjusting for edge trim</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="effective_deckle_length"
                                                                
                                  className=""
                                  shouldUpdate
                                >
                                
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row> */}
                                              {/* <Row className="centerAlign">
                                                <Col
                                                  span={12}
                                                  style={{
                                                    paddingRight: "20px",
                                                  }}
                                                >
                                                  <div className="boxFieldTitle">
                                                    <label>
                                                      Effective Deckle Length
                                                    </label>
                                                    <p>
                                                      Available deckle length to
                                                      match deckle after
                                                      adjusting for edge trim
                                                    </p>
                                                  </div>
                                                </Col>
                                                <Col span={12}>
                                                  <div className="boxFormType">
                                                    <Form.Item
                                                      name="effective_deckle_length"
                                                      className=""
                                                      initialValue={
                                                        formValues
                                                          ?.machine_data?.[0]
                                                          ?.effective_deckle_length
                                                          ? formValues
                                                              .machine_data?.[0]
                                                              ?.effective_deckle_length
                                                          : location.state?.body
                                                              ?.machine_data?.[0]
                                                              ?.effective_deckle_length
                                                          ? location.state?.body
                                                              ?.machine_data?.[0]
                                                              ?.effective_deckle_length
                                                          : ""
                                                      }
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This is a required field",
                                                        },
                                                      ]}
                                                      shouldUpdate
                                                    >
                                                      <Input
                                                        disabled
                                                        value={effectiveDeckle.toString()}
                                                        placeholder="Enter Deckle Length"
                                                        suffix={
                                                          <label className="floating-label">
                                                            {form.getFieldValue(
                                                              "Unit"
                                                            )}
                                                          </label>
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </PaperBlockList> */}
                                            <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle">
                                                  <label>
                                                    Maximum Number of cutters
                                                  </label>
                                                  <p>
                                                    Specify maximum number of
                                                    cutters including edge
                                                    cutters which can be placed
                                                    on deckle
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col span={12}>
                                                <div className="boxFormType">
                                                  <Form.Item
                                                    name="cutters"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d+)?$/
                                                        ),
                                                        message:
                                                          "Only numerical values are allowed",
                                                      },
                                                      {
                                                        validator(_, value) {
                                                          if (value == 0)
                                                            return Promise.reject(
                                                              "Cutters should be more than 0"
                                                            );
                                                          else
                                                            return Promise.resolve();
                                                        },
                                                      },
                                                    ]}
                                                    initialValue={
                                                      maxNoOfCutters
                                                        ? maxNoOfCutters
                                                        : ""
                                                    }
                                                    className=""
                                                  >
                                                    <Input placeholder="Maximum Number of cutters" />
                                                  </Form.Item>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Panel>
                                        </Collapse>
                                      </CollapseStyle>
                                    </Row>
                                    <Row
                                      className="centerAlign"
                                      style={{ width: "100%" }}
                                    >
                                      <CollapseStyle style={{ width: "100%" }}>
                                        <Collapse
                                          // onChange={onChangeCollpase}
                                          expandIconPosition="right"
                                          bordered={false}
                                          style={{
                                            backgroundColor: "white",
                                            width: "100%",
                                          }}
                                        >
                                          <Panel
                                            forceRender={true}
                                            header={
                                              "Cutter Specification: " +
                                              selectedCutter +
                                              " ( " +
                                              capitalize(
                                                allCutters?.find(
                                                  (cutter) =>
                                                    cutter?.name ===
                                                    selectedCutter
                                                )?.type
                                              ) +
                                              " )"
                                            }
                                            // key="1"
                                          >
                                            <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle removeStar">
                                                  <label>Edge Trim</label>
                                                  <p>
                                                    Specify the left and right
                                                    edge trim for the machine
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col
                                                span={12}
                                                className="d-flex threeFields"
                                              >
                                                <div
                                                  className="boxFormType"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="min_width_cutter"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d{0,3})?$/
                                                        ),
                                                        message:
                                                          "Invalid input",
                                                      },
                                                      // {
                                                      //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                                                      //   message:
                                                      //     "Only numerical values are allowed",
                                                      // },
                                                    ]}
                                                    initialValue={
                                                      leftEdgeTrimForCutter ==
                                                        0 ||
                                                      leftEdgeTrimForCutter ==
                                                        "0" ||
                                                      leftEdgeTrimForCutter ==
                                                        null
                                                        ? 0
                                                        : leftEdgeTrimForCutter
                                                        ? leftEdgeTrimForCutter
                                                        : ""
                                                    }
                                                    label="Left Trim"
                                                    className="dBlock"
                                                  >
                                                    <Input
                                                      placeholder="Left trim"
                                                      onChange={() => {
                                                        // setLeftTrim(e.target.value);
                                                        changeDeckleLength();
                                                      }}
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div
                                                  className="boxFormType"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="max_width_cutter"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d{0,3})?$/
                                                        ),
                                                        message:
                                                          "Invalid input",
                                                      },
                                                    ]}
                                                    initialValue={
                                                      rightEdgeTrimForCutter ==
                                                        0 ||
                                                      rightEdgeTrimForCutter ==
                                                        "0" ||
                                                      rightEdgeTrimForCutter ==
                                                        null
                                                        ? 0
                                                        : rightEdgeTrimForCutter
                                                        ? rightEdgeTrimForCutter
                                                        : ""
                                                    }
                                                    label="Right Trim"
                                                    className="dBlock"
                                                  >
                                                    <Input
                                                      placeholder="Right trim"
                                                      onChange={() => {
                                                        // setRightTrim(e.target.value);
                                                        changeDeckleLength();
                                                      }}
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div
                                                  className="boxFormType unitSelect"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="unit_cutter"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                    ]}
                                                    initialValue={
                                                      formValues
                                                      ? formValues?.unit_cutter
                                                      : cutterUnits?.left_edge_trim
                                                    }
                                                    label="Unit"
                                                    className="dBlock"
                                                  >
                                                    <Select
                                                      placeholder="Unit"
                                                      suffixIcon={
                                                        <DownArrowDraw />
                                                      }
                                                      onChange={() => {
                                                        changeDeckleLength();
                                                      }}
                                                    >
                                                      {unitData?.units_management?.length?.data?.map(
                                                        (deckleWidth) => (
                                                          <Option
                                                            key={deckleWidth}
                                                          >
                                                            {
                                                              lengthUnit[
                                                                deckleWidth
                                                              ].displayName
                                                            }
                                                          </Option>
                                                        )
                                                      )}
                                                    </Select>
                                                  </Form.Item>
                                                </div>
                                              </Col>
                                            </Row>

                                            <PaperBlockList>
                                              {/* <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label>Effective Deckle Length</label>
                                <p>Available deckle length to match deckle after adjusting for edge trim</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <Form.Item
                                  name="effective_deckle_length"
                                                                
                                  className=""
                                  shouldUpdate
                                >
                                
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                    >
                                      {deckleWidthData.map((deckleWidth) => (
                                        <Option key={deckleWidth}>
                                          {deckleWidth}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row> */}
                                              <Row className="centerAlign">
                                                <Col
                                                  span={12}
                                                  style={{
                                                    paddingRight: "20px",
                                                  }}
                                                >
                                                  <div className="boxFieldTitle">
                                                    <label>
                                                      Effective Deckle Length
                                                    </label>
                                                    <p>
                                                      Available deckle length to
                                                      match deckle after
                                                      adjusting for edge trim
                                                    </p>
                                                  </div>
                                                </Col>
                                                <Col span={12}>
                                                  <div className="boxFormType">
                                                    <Form.Item
                                                      name="effective_deckle_length_cutter"
                                                      className=""
                                                      initialValue={
                                                        formValues
                                                          ?.machine_data?.[1]
                                                          ?.effective_deckle_length_cutter
                                                          ? formValues
                                                              .machine_data?.[1]
                                                              ?.effective_deckle_length_cutter
                                                          : location.state?.body
                                                              ?.machine_data?.[1]
                                                              ?.effective_deckle_length_cutter
                                                          ? location.state?.body
                                                              ?.machine_data?.[1]
                                                              ?.effective_deckle_length_cutter
                                                          : ""
                                                      }
                                                      shouldUpdate
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message:
                                                            "This is a required field",
                                                        },
                                                      ]}
                                                    >
                                                      <Input
                                                        disabled
                                                        // value={effectiveDeckle.toString()}
                                                        placeholder="Enter Deckle Length"
                                                        suffix={
                                                          <label className="floating-label">
                                                            {form.getFieldValue(
                                                              "unit_cutter"
                                                            )}
                                                          </label>
                                                        }
                                                      />
                                                    </Form.Item>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </PaperBlockList>
                                            <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle">
                                                  <label>
                                                    Maximum Number of cutters
                                                  </label>
                                                  <p>
                                                    Specify maximum number of
                                                    cutters including edge
                                                    cutters which can be placed
                                                    on deckle
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col span={12}>
                                                <div className="boxFormType">
                                                  <Form.Item
                                                    name="cutters_cutter"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d+)?$/
                                                        ),
                                                        message:
                                                          "Only numerical values are allowed",
                                                      },
                                                      {
                                                        validator(_, value) {
                                                          if (value == 0)
                                                            return Promise.reject(
                                                              "Cutters should be more than 0"
                                                            );
                                                          else
                                                            return Promise.resolve();
                                                        },
                                                      },
                                                    ]}
                                                    initialValue={
                                                      maxNoOfCuttersForCutter
                                                        ? maxNoOfCuttersForCutter
                                                        : ""
                                                    }
                                                    className=""
                                                  >
                                                    <Input placeholder="Maximum Number of cutters" />
                                                  </Form.Item>
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle removeStar">
                                                  <label>Chop Size Range</label>
                                                  <p>
                                                    Specify the minimum and
                                                    maximum chop size that can
                                                    be cut on this cutter
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col
                                                span={12}
                                                className="d-flex threeFields"
                                              >
                                                <div
                                                  className="boxFormType"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="min_chop"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d{0,3})?$/
                                                        ),
                                                        message:
                                                          "Invalid input",
                                                      },
                                                      {
                                                        validator(_, value) {
                                                          if (
                                                            value >
                                                            parseFloat(
                                                              form.getFieldValue(
                                                                "max_chop"
                                                              )
                                                            )
                                                          ) {
                                                            return Promise.reject(
                                                              "Max chop size cannot be less than Min chop size"
                                                            );
                                                          } else {
                                                            return Promise.resolve();
                                                          }
                                                        },
                                                      },
                                                      // {
                                                      //   pattern: new RegExp(/^\d+(\.\d+)?$/),
                                                      //   message:
                                                      //     "Only numerical values are allowed",
                                                      // },
                                                    ]}
                                                    initialValue={
                                                      formValues
                                                        ?.machine_data?.[1]
                                                        ?.minimum_chop_size
                                                        ? formValues
                                                            ?.machine_data?.[1]
                                                            ?.minimum_chop_size
                                                        : allCutters?.find(
                                                            (cutter) =>
                                                              cutter?.name ===
                                                              selectedCutter
                                                          )?.minimum_chop_size
                                                    }
                                                    label="Min Chop Size"
                                                    className="dBlock"
                                                  >
                                                    <Input
                                                      placeholder="Min Chop Size"
                                                      // onChange={() => {
                                                      //   // setLeftTrim(e.target.value);
                                                      //   changeDeckleLength();
                                                      // }}
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div
                                                  className="boxFormType"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="max_chop"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                      {
                                                        pattern: new RegExp(
                                                          /^\d+(\.\d{0,3})?$/
                                                        ),
                                                        message:
                                                          "Invalid input",
                                                      },
                                                    ]}
                                                    initialValue={
                                                      formValues
                                                        ?.machine_data?.[1]
                                                        ?.maximum_chop_size
                                                        ? formValues
                                                            ?.machine_data?.[1]
                                                            ?.maximum_chop_size
                                                        : allCutters?.find(
                                                            (cutter) =>
                                                              cutter?.name ===
                                                              selectedCutter
                                                          )?.maximum_chop_size
                                                    }
                                                    label="Max Chop  Size"
                                                    className="dBlock"
                                                  >
                                                    <Input
                                                      placeholder="Max Chop Size"
                                                      // onChange={() => {
                                                      //   // setRightTrim(e.target.value);
                                                      //   changeDeckleLength();
                                                      // }}
                                                    />
                                                  </Form.Item>
                                                </div>
                                                <div
                                                  className="boxFormType unitSelect"
                                                  style={{ marginBottom: "0" }}
                                                >
                                                  <Form.Item
                                                    name="chop_unit"
                                                    rules={[
                                                      {
                                                        required: true,
                                                        message:
                                                          "This is a required field",
                                                      },
                                                    ]}
                                                    initialValue={
                                                      formValues
                                                        ?.machine_data?.[1]
                                                        ?.units
                                                        ?.minimum_chop_size
                                                        ? formValues
                                                            .machine_data?.[1]
                                                            ?.units
                                                            .minimum_chop_size
                                                        : allCutters?.find(
                                                            (cutter) =>
                                                              cutter?.name ===
                                                              selectedCutter
                                                          )?.units
                                                            ?.minimum_chop_size
                                                    }
                                                    label="Unit"
                                                    className="dBlock"
                                                  >
                                                    <Select
                                                      placeholder="Unit"
                                                      suffixIcon={
                                                        <DownArrowDraw />
                                                      }
                                                      // onChange={() => {
                                                      //   changeDeckleLength();
                                                      // }}
                                                    >
                                                      {unitData?.units_management?.length?.data?.map(
                                                        (deckleWidth) => (
                                                          <Option
                                                            key={deckleWidth}
                                                          >
                                                            {
                                                              lengthUnit[
                                                                deckleWidth
                                                              ].displayName
                                                            }
                                                          </Option>
                                                        )
                                                      )}
                                                    </Select>
                                                  </Form.Item>
                                                </div>
                                              </Col>
                                            </Row>
                                            <Row
                                              className="centerAlign"
                                              style={{ width: "100%" }}
                                            >
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle removeStar">
                                                  <label>
                                                    Reel Diameter Range
                                                  </label>
                                                  <p>
                                                    Specify the minimum and
                                                    maximum reel diameter that
                                                    the cutter can handle
                                                  </p>
                                                </div>
                                              </Col>
                                              <Col span={12}>
                                                <Row className="centerAlign">
                                                  <Col
                                                    className="d-flex threeFields"
                                                    style={{ width: "100%" }}
                                                  >
                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                      }}
                                                    >
                                                      <Form.Item
                                                        name="min_dia"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "This is a required field",
                                                          },
                                                          {
                                                            pattern: new RegExp(
                                                              /^\d+(\.\d{0,3})?$/
                                                            ),
                                                            message:
                                                              "Invalid input",
                                                          },
                                                          // {
                                                          //   pattern: new RegExp(
                                                          //     /^0*[1-9]\d*$/
                                                          //   ),
                                                          //   message:
                                                          //     "Min. reel dia cannot be zero",
                                                          // },
                                                          {
                                                          validator(_, value) {
                                                            if (value && value == 0) {
                                                              return Promise.reject(
                                                                "Min. reel dia cannot be zero"
                                                              );
                                                            } else{
                                                              return Promise.resolve();
                                                            }
                                                          },
                                                        },
                                                        ]}
                                                        initialValue={
                                                          formValues
                                                            ?.machine_data?.[1]
                                                            ?.minimum_reel_dia
                                                            ? formValues
                                                                ?.machine_data?.[1]
                                                                ?.minimum_reel_dia
                                                            : allCutters?.find(
                                                                (cutter) =>
                                                                  cutter?.name ===
                                                                  selectedCutter
                                                              )
                                                                ?.minimum_reel_dia
                                                        }
                                                        label="Min Dia"
                                                        className="dBlock"
                                                      >
                                                        <Input
                                                          placeholder="Min Dia"
                                                          // onChange={() => {
                                                          //   // setLeftTrim(e.target.value);
                                                          //   changeDeckleLength();
                                                          // }}
                                                          onChange={
                                                            onDiaValidation
                                                          }
                                                        />
                                                      </Form.Item>
                                                    </div>
                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                      }}
                                                    >
                                                      <Form.Item
                                                        name="max_dia"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "This is a required field",
                                                          },
                                                          {
                                                            pattern: new RegExp(
                                                              /^\d+(\.\d{0,3})?$/
                                                            ),
                                                            message:
                                                              "Invalid input",
                                                          },
                                                          // {
                                                          //   pattern: new RegExp(
                                                          //     /^0*[1-9]\d*$/
                                                          //   ),
                                                          //   message:
                                                          //     "Max. reel dia cannot be zero",
                                                          // },
                                                          {
                                                          validator(_, value) {
                                                            if (value && value == 0) {
                                                              return Promise.reject(
                                                                "Max. reel dia cannot be zero"
                                                              );
                                                            } else{
                                                              return Promise.resolve();
                                                            }
                                                          },
                                                        },
                                                        ]}
                                                        initialValue={
                                                          formValues
                                                            ?.machine_data?.[1]
                                                            ?.maximum_reel_dia
                                                            ? formValues
                                                                ?.machine_data?.[1]
                                                                ?.maximum_reel_dia
                                                            : allCutters?.find(
                                                                (cutter) =>
                                                                  cutter?.name ===
                                                                  selectedCutter
                                                              )
                                                                ?.maximum_reel_dia
                                                        }
                                                        label="Max Dia"
                                                        className="dBlock"
                                                      >
                                                        <Input
                                                          placeholder="Max Dia"
                                                          // onChange={() => {
                                                          //   // setRightTrim(e.target.value);
                                                          //   changeDeckleLength();
                                                          // }}
                                                          onChange={
                                                            onDiaValidation
                                                          }
                                                        />
                                                      </Form.Item>
                                                    </div>
                                                    <div
                                                      className="boxFormType unitSelect"
                                                      style={{
                                                        marginBottom: "0",
                                                      }}
                                                    >
                                                      <Form.Item
                                                        name="dia_unit"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "This is a required field",
                                                          },
                                                        ]}
                                                        initialValue={
                                                          formValues
                                                            ?.machine_data?.[1]
                                                            ?.units
                                                            ?.minimum_reel_dia
                                                            ? formValues
                                                                .machine_data?.[1]
                                                                ?.units
                                                                ?.minimum_reel_dia
                                                            : allCutters?.find(
                                                                (cutter) =>
                                                                  cutter?.name ===
                                                                  selectedCutter
                                                              )?.units
                                                                ?.minimum_reel_dia
                                                        }
                                                        label="Unit"
                                                        className="dBlock"
                                                      >
                                                        <Select
                                                          placeholder="Unit"
                                                          suffixIcon={
                                                            <DownArrowDraw />
                                                          }
                                                          // onChange={() => {
                                                          //   changeDeckleLength();
                                                          // }}
                                                        >
                                                          {unitData?.units_management?.length?.data?.map(
                                                            (deckleWidth) => (
                                                              <Option
                                                                key={
                                                                  deckleWidth
                                                                }
                                                              >
                                                                {
                                                                  lengthUnit[
                                                                    deckleWidth
                                                                  ].displayName
                                                                }
                                                              </Option>
                                                            )
                                                          )}
                                                        </Select>
                                                      </Form.Item>
                                                    </div>
                                                  </Col>
                                                  {isDiaError ? (
                                                    <span
                                                      className="errorText"
                                                      style={{
                                                        color: "#ea4e2c",
                                                      }}
                                                    >
                                                      Max dia cannot be less
                                                      than Min dia
                                                    </span>
                                                  ) : null}
                                                </Row>
                                              </Col>
                                            </Row>
                                            <Row className="centerAlign">
                                              <Col
                                                span={12}
                                                style={{ paddingRight: "20px" }}
                                              >
                                                <div className="boxFieldTitle removeStar">
                                                  <label>
                                                    Maximum Trim on Intermediate
                                                    Reel
                                                  </label>
                                                  <p>
                                                    Specify the maximum trim
                                                    other than edge trims
                                                    allowed on intermediate
                                                    reel. This will be used only
                                                    when minimum size that can
                                                    be cut on cutter cant be
                                                    achieved without adding some
                                                    trim.
                                                  </p>
                                                </div>
                                              </Col>

                                              <Col span={12}>
                                                <Row className="centerAlign">
                                                  <Col
                                                    span={24}
                                                    className="d-flex twoFields"
                                                  >
                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                      }}
                                                    >
                                                      <Form.Item
                                                        name="max_trim"
                                                        rules={[
                                                          {
                                                            pattern: new RegExp(
                                                              /^\d+(\.\d{0,3})?$/
                                                            ),
                                                            message:
                                                              "Invalid input",
                                                          },
                                                          // {
                                                          //   validator(_, value) {
                                                          //      if ((value * CoversionFactorUnitsToCM[cutterUnit.toLowerCase()]) > parseFloat(cutterMaxWidth * CoversionFactorUnitsToCM[form.getFieldValue('trim_unit')])) {
                                                          //       return Promise.reject("Trim cannot be greater than maximum deckle");
                                                          //     } else {
                                                          //       return Promise.resolve();
                                                          //     }
                                                          //   },
                                                          // },
                                                        ]}
                                                        initialValue={
                                                          formValues
                                                            ?.machine_data?.[1]
                                                            ?.allowed_trim
                                                            ? formValues
                                                                .machine_data?.[1]
                                                                ?.allowed_trim
                                                            : 0
                                                        }
                                                        className="dBlock"
                                                      >
                                                        <Input
                                                          onChange={() => {
                                                            onTrimValidation();
                                                          }}
                                                        />
                                                      </Form.Item>
                                                    </div>

                                                    <div
                                                      className="boxFormType"
                                                      style={{
                                                        marginBottom: "0",
                                                      }}
                                                    >
                                                      <Form.Item
                                                        name="trim_unit"
                                                        rules={[
                                                          {
                                                            required: true,
                                                            message:
                                                              "This is a required field",
                                                          },
                                                        ]}
                                                        initialValue={
                                                          formValues
                                                            ?.machine_data?.[1]
                                                            ?.units
                                                            ?.allowed_trim
                                                            ? formValues
                                                                .machine_data?.[1]
                                                                .units
                                                                ?.allowed_trim
                                                            : unitData
                                                                ?.units_management
                                                                ?.length.default
                                                        }
                                                        className="dBlock"
                                                      >
                                                        <Select
                                                          suffixIcon={
                                                            <DownArrowDraw />
                                                          }
                                                          onChange={() => {
                                                            onTrimValidation();
                                                          }}
                                                        >
                                                          {unitData?.units_management?.length?.data?.map(
                                                            (deckleWidth) => (
                                                              <Option
                                                                key={
                                                                  deckleWidth
                                                                }
                                                              >
                                                                {
                                                                  lengthUnit[
                                                                    deckleWidth
                                                                  ].displayName
                                                                }
                                                              </Option>
                                                            )
                                                          )}
                                                        </Select>
                                                      </Form.Item>
                                                    </div>
                                                  </Col>
                                                  {trimValidaton ? (
                                                    <span
                                                      className="errorText"
                                                      style={{
                                                        color: "#ea4e2c",
                                                      }}
                                                    >
                                                      Trim cannot be greater
                                                      than maximum deckle
                                                    </span>
                                                  ) : null}
                                                </Row>
                                              </Col>
                                            </Row>
                                          </Panel>
                                        </Collapse>
                                      </CollapseStyle>
                                    </Row>
                                  </>
                                )}
                              </PaperBlockList>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    </HaberForm>
                  </DetailFields>
                )}
            </Col>
          </Row>
        </Layout>
      </RightLayoutContainer>
    )
  );
};

export default PaperMachineData;
